import { List } from "linqts";
import {
  AMPMDefault,
  ColDefDataFormats,
  ColumnDefenitionType,
} from "../enums/global-enum-constant";
import { ColumnDefintion } from "../models/ColumnDefintion";
import {
  CommutingAuto,
  CommutingManual,
  CrewbidState,
  Key1,
  Key2,
  Key5,
  KeyPDO,
  OverNightCityState,
  ReportRelease,
} from "../models/CrewbidState";
import { FilterPopUpData } from "../models/FilterPopUpData";
import { QuickFilterUIList } from "../models/QuickFilterUIList";
import { SortPopUpData } from "../models/SortPopUpData";
import { FlagColorList } from "../models/FlagColorList";
import { Injectable } from "@angular/core";

@Injectable()
export class CrewbidCollection {
  /**
   * @method getColumnDefinitionData - Hard Coded Line Properties
   */
  public getColumnDefinitionData = (): List<ColumnDefintion> => {
    const lstDefaultColumnData = new List<ColumnDefintion>();

    lstDefaultColumnData.Add(
      new ColumnDefintion(
        1,
        "Total Pay",
        "TotalPay",
        "TempTfp",
        ColumnDefenitionType.VacForAll,
        ColDefDataFormats.FloatDoubleDec
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        2,
        "Fly Pay",
        "FlyPay",
        "FlyPay",
        ColumnDefenitionType.VacForAll,
        ColDefDataFormats.FloatDoubleDec
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        3,
        "Vacation Pay in BP",
        "vpCu",
        "VacPayCuBp",
        ColumnDefenitionType.VacForAll,
        ColDefDataFormats.FloatDoubleDec
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        4,
        "Vacay Carry Out Pay",
        "vpNe",
        "CarryOutVacationPay",
        ColumnDefenitionType.VacForFA,
        ColDefDataFormats.FloatDoubleDec
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        5,
        "Vacation Pay next BP",
        "vpNe",
        "VacPayNeBp",
        ColumnDefenitionType.VacForPilot,
        ColDefDataFormats.FloatDoubleDec
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        6,
        "Vacation Pay both BP",
        "vpBo",
        "VacPayBothBp",
        ColumnDefenitionType.VacForAll,
        ColDefDataFormats.FloatDoubleDec
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        7,
        "Pay Per Block",
        "$/Blk",
        "TempTfpPerFltHr",
        ColumnDefenitionType.VacForAll,
        ColDefDataFormats.FloatDoubleDec
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        8,
        "Pay Per Day",
        "$/Day",
        "TempTfpPerDay",
        ColumnDefenitionType.VacForAll,
        ColDefDataFormats.FloatDoubleDec
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        9,
        "Carry Out Pay",
        "CoPay",
        "CarryOverTfp",
        ColumnDefenitionType.Ignored,
        ColDefDataFormats.FloatDoubleDec
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        10,
        "Carry Out VO Pay",
        "---",
        "7",
        ColumnDefenitionType.Ignored,
        ColDefDataFormats.FloatDoubleDec
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        11,
        "Block Time",
        "BlkHrs",
        "TempBlkHrsInBp",
        ColumnDefenitionType.VacForAll,
        ColDefDataFormats.TimeTotHours
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        12,
        "Days Off",
        "DaysOff",
        "TempDaysOff",
        ColumnDefenitionType.VacForAll,
        ColDefDataFormats.Number
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        13,
        "Effective Vacation Length",
        "EffLength",
        "EffectiveVacationLength",
        ColumnDefenitionType.VacForPilot,
        ColDefDataFormats.Number
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        14,
        "Longest Blk Off",
        "$/Duty",
        "---",
        ColumnDefenitionType.Ignored,
        ColDefDataFormats.FloatDoubleDec
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        15,
        "Front VO Pay",
        "$/Leg",
        "---",
        ColumnDefenitionType.Ignored,
        ColDefDataFormats.FloatDoubleDec
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        16,
        "Back VO Pay",
        "$/TAFB",
        "---",
        ColumnDefenitionType.Ignored,
        ColDefDataFormats.FloatDoubleDec
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        17,
        "vDiff",
        "vDiff",
        "vDiff",
        ColumnDefenitionType.VacForPilot,
        ColDefDataFormats.FloatDoubleDecWithColor
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        58,
        "Front VO Pay",
        "VoFront",
        "VacationOverlapFront",
        ColumnDefenitionType.VacForAll,
        ColDefDataFormats.FloatDoubleDec
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        59,
        "Back VO Pay",
        "VoBack",
        "VacationOverlapBack",
        ColumnDefenitionType.VacForAll,
        ColDefDataFormats.FloatDoubleDec
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        60,
        "VoBoth",
        "VoBoth",
        "VacationOverlapBoth",
        ColumnDefenitionType.VacForAll,
        ColDefDataFormats.FloatDoubleDec
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        61,
        "VAbp",
        "VAbp",
        "VAbp",
        ColumnDefenitionType.VacForAll,
        ColDefDataFormats.FloatDoubleDec
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        62,
        "VAne",
        "VAne",
        "VAne",
        ColumnDefenitionType.VacForAll,
        ColDefDataFormats.FloatDoubleDec
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        63,
        "VAbo",
        "VAbo",
        "VAbo",
        ColumnDefenitionType.VacForAll,
        ColDefDataFormats.FloatDoubleDec
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        88,
        "VAPbp",
        "VAPbp",
        "VAPbp",
        ColumnDefenitionType.VacForAll,
        ColDefDataFormats.FloatDoubleDec
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        89,
        "VAPne",
        "VAPne",
        "VAPne",
        ColumnDefenitionType.VacForAll,
        ColDefDataFormats.FloatDoubleDec
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        90,
        "VAPbo",
        "VAPbo",
        "VAPbo",
        ColumnDefenitionType.VacForAll,
        ColDefDataFormats.FloatDoubleDec
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        101,
        "ClawBack",
        "ClawBack",
        "clawBack",
        ColumnDefenitionType.VacForAll,
        ColDefDataFormats.FloatDoubleDec
      )
    );

    lstDefaultColumnData.Add(
      new ColumnDefintion(
        65,
        "Total Pay",
        "TotalPay",
        "TempTfp",
        ColumnDefenitionType.VacForSwap,
        ColDefDataFormats.FloatDoubleDec
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        66,
        "Fly Pay",
        "FlyPay",
        "FlyPay",
        ColumnDefenitionType.VacForSwap,
        ColDefDataFormats.FloatDoubleDec
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        67,
        "Vacation Pay in BP",
        "vpCu",
        "VacPayCuBp",
        ColumnDefenitionType.VacForSwap,
        ColDefDataFormats.FloatDoubleDec
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        68,
        "Carry Out Pay",
        "CoFlyPay",
        "CarryOutPay",
        ColumnDefenitionType.VacForSwap,
        ColDefDataFormats.FloatDoubleDec
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        69,
        "Pay Per Block",
        "$/Blk",
        "TempTfpPerFltHr",
        ColumnDefenitionType.VacForSwap,
        ColDefDataFormats.FloatDoubleDec
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        70,
        "Pay Per Day",
        "$/Day",
        "TempTfpPerDay",
        ColumnDefenitionType.VacForSwap,
        ColDefDataFormats.FloatDoubleDec
      )
    );
    // lstDefaultColumnData.Add(
    //   new ColumnDefintion(
    //     70,
    //     "Carry Out VO Pay",
    //     "vCOutVOPay",
    //     "vCOutVOPay",
    //     ColumnDefenitionType.Ignored,
    //     ColDefDataFormats.FloatDoubleDec
    //   )
    // );

    lstDefaultColumnData.Add(
      new ColumnDefintion(
        71,
        "Block Time",
        "BlkHrs",
        "TempBlkHrsInBp",
        ColumnDefenitionType.VacForSwap,
        ColDefDataFormats.TimeTotHours
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        72,
        "Days Off",
        "DaysOff",
        "TempDaysOff",
        ColumnDefenitionType.VacForSwap,
        ColDefDataFormats.Number
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        73,
        "Effective Vacation Length",
        "EffLength",
        "EffectiveVacationLength",
        ColumnDefenitionType.VacForSwap,
        ColDefDataFormats.Number
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        74,
        "Longest Blk Off",
        "LonBlkoff",
        "vLongest",
        ColumnDefenitionType.VacForSwap,
        ColDefDataFormats.FloatDoubleDec
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        75,
        "Front VO Pay",
        "FrontVO",
        "VacationOverlapFront",
        ColumnDefenitionType.VacForSwap,
        ColDefDataFormats.FloatDoubleDec
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        76,
        "Back VO Pay",
        "BackVO",
        "VacationOverlapBack",
        ColumnDefenitionType.VacForSwap,
        ColDefDataFormats.FloatDoubleDec
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        77,
        "vDiff",
        "vDiff",
        "vDiff",
        ColumnDefenitionType.VacForSwap,
        ColDefDataFormats.FloatDoubleDecWithColor
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        78,
        "VAbp",
        "VAbp",
        "VAbp",
        ColumnDefenitionType.VacForSwap,
        ColDefDataFormats.FloatDoubleDec
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        79,
        "VAne",
        "VAne",
        "VAne",
        ColumnDefenitionType.VacForSwap,
        ColDefDataFormats.FloatDoubleDec
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        80,
        "VAbo",
        "VAbo",
        "VAbo",
        ColumnDefenitionType.VacForSwap,
        ColDefDataFormats.FloatDoubleDec
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        81,
        "VAPbp",
        "VAPbp",
        "VAPbp",
        ColumnDefenitionType.VacForSwap,
        ColDefDataFormats.FloatDoubleDec
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        82,
        "VAPne",
        "VAPne",
        "VAPne",
        ColumnDefenitionType.VacForSwap,
        ColDefDataFormats.FloatDoubleDec
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        83,
        "VAPbo",
        "VAPbo",
        "VAPbo",
        ColumnDefenitionType.VacForSwap,
        ColDefDataFormats.FloatDoubleDec
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        18,
        "Aircraft Changes",
        "Chngs",
        "AcftChanges",
        ColumnDefenitionType.Normal,
        ColDefDataFormats.Number
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        19,
        "Aircraft Type 800",
        "800s",
        "LegsIn800",
        ColumnDefenitionType.Normal,
        ColDefDataFormats.Number
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        20,
        "Aircraft Type 700",
        "700s",
        "LegsIn700",
        ColumnDefenitionType.Normal,
        ColDefDataFormats.Number
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        21,
        "Aircraft Type 8Max",
        "8Max",
        "LegsIn600",
        ColumnDefenitionType.Normal,
        ColDefDataFormats.Number
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        22,
        "Aircraft Type 7Max",
        "7Max",
        "LegsIn200",
        ColumnDefenitionType.Normal,
        ColDefDataFormats.Number
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        23,
        "Block of Days Off",
        "BlkOff",
        "LargestBlkOfDaysOff",
        ColumnDefenitionType.Normal,
        ColDefDataFormats.Number
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        24,
        "Block Time",
        "BlkHrs",
        "BlkHrsInBp",
        ColumnDefenitionType.Normal,
        ColDefDataFormats.TimeTotHours
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        25,
        "cmts",
        "cmts",
        "TotalCommutes",
        ColumnDefenitionType.Normal,
        ColDefDataFormats.Number
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        26,
        "cmtFr",
        "cmtFr",
        "commutableFronts",
        ColumnDefenitionType.Normal,
        ColDefDataFormats.Number
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        27,
        "cmtBa",
        "cmtBa",
        "CommutableBacks",
        ColumnDefenitionType.Normal,
        ColDefDataFormats.Number
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        28,
        "cmt%Fr",
        "cmt%Fr",
        "CommutabilityFront",
        ColumnDefenitionType.Normal,
        ColDefDataFormats.Percentage
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        29,
        "cmt%Ba",
        "cmt%Ba",
        "CommutabilityBack",
        ColumnDefenitionType.Normal,
        ColDefDataFormats.Percentage
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        30,
        "cmt%Ov",
        "cmt%Ov",
        "CommutabilityOverall",
        ColumnDefenitionType.Normal,
        ColDefDataFormats.Percentage
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        98,
        "CoHoli",
        "CoHoli",
        "CoHoli",
        ColumnDefenitionType.Normal,
        ColDefDataFormats.FloatDoubleDec
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        100,
        "Co+Holi",
        "Co+Holi",
        "CoPlusHoli",
        ColumnDefenitionType.Normal,
        ColDefDataFormats.FloatDoubleDec
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        31,
        "Carry Out Pay",
        "CoPay",
        "CarryOverTfp",
        ColumnDefenitionType.Normal,
        ColDefDataFormats.FloatDoubleDec
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        32,
        "Days Off",
        "DaysOff",
        "DaysOff",
        ColumnDefenitionType.Normal,
        ColDefDataFormats.Number
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        92,
        "Days Of Reserve",
        "DoR",
        "DoR",
        ColumnDefenitionType.Normal,
        ColDefDataFormats.Number
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        33,
        "Deadheads",
        "DHs",
        "DeadHead",
        ColumnDefenitionType.Normal,
        ColDefDataFormats.Number
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        34,
        "Duty Hours",
        "DtyHrs",
        "DutyHrsInLine",
        ColumnDefenitionType.Normal,
        ColDefDataFormats.TimeTotHours
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        35,
        "Duty Hours Per Day",
        "DtyDay",
        "DutyHrsPerDay",
        ColumnDefenitionType.Normal,
        ColDefDataFormats.FloatDoubleDec
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        36,
        "Earliest Departure",
        "EDep",
        "EDomPush",
        ColumnDefenitionType.Normal,
        ColDefDataFormats.TimeHHmm
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        84,
        "eTrips",
        "eTrips",
        "ETOPSTripsCount",
        ColumnDefenitionType.Normal,
        ColDefDataFormats.Number
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        87,
        "Ground Time Average",
        "GTAvg",
        "GTavg",
        ColumnDefenitionType.Normal,
        ColDefDataFormats.TimeHHmm
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        86,
        "Ground Time Max",
        "GTMax",
        "GTmax",
        ColumnDefenitionType.Normal,
        ColDefDataFormats.TimeHHmm
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        37,
        "HoliRig",
        "HoliRig",
        "HolRig",
        ColumnDefenitionType.Normal,
        ColDefDataFormats.FloatDoubleDec
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        38,
        "Latest Arrival",
        "LArr",
        "LastDomArrTime",
        ColumnDefenitionType.Normal,
        ColDefDataFormats.TimeHHmm
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        39,
        "Legs",
        "Legs",
        "Legs",
        ColumnDefenitionType.Normal,
        ColDefDataFormats.Number
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        40,
        "Line Rig",
        "LineRig",
        "LineRig",
        ColumnDefenitionType.Normal,
        ColDefDataFormats.FloatDoubleDec
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        41,
        "Max Legs in a Day",
        "MLegs",
        "MaxLegsDay",
        ColumnDefenitionType.Normal,
        ColDefDataFormats.Number
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        42,
        "NonConUS Legs",
        "NC Legs",
        "NonConusCount",
        ColumnDefenitionType.Normal,
        ColDefDataFormats.Number
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        43,
        "nMid",
        "nMid",
        "NightsInMid",
        ColumnDefenitionType.Normal,
        ColDefDataFormats.Number
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        91,
        "Overnight Average",
        "OvAvg",
        "OvAvg",
        ColumnDefenitionType.Normal,
        ColDefDataFormats.TimeHHmm
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        44,
        "Overnights in Base",
        "OIBs",
        "OvernightInBase",
        ColumnDefenitionType.Normal,
        ColDefDataFormats.Number
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        45,
        "Passes Through Base",
        "PTBs",
        "PassThruBase",
        ColumnDefenitionType.Normal,
        ColDefDataFormats.Number
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        46,
        "Pay",
        "Pay",
        "Tfp",
        ColumnDefenitionType.Normal,
        ColDefDataFormats.FloatDoubleDec
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        99,
        "Pay+CO",
        "Pay+CO",
        "PayPlusCO",
        ColumnDefenitionType.Normal,
        ColDefDataFormats.FloatDoubleDec
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        47,
        "Pay Per Block Hour",
        "$/Blk",
        "TfpPerFltHr",
        ColumnDefenitionType.Normal,
        ColDefDataFormats.FloatDoubleDec
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        48,
        "Pay Per Day",
        "$/Day",
        "TfpPerDay",
        ColumnDefenitionType.Normal,
        ColDefDataFormats.FloatDoubleDec
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        49,
        "Pay Per Duty Hour",
        "$/Duty",
        "TfpPerDhr",
        ColumnDefenitionType.Normal,
        ColDefDataFormats.FloatDoubleDec
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        50,
        "Pay Per Leg",
        "$/Leg",
        "TfpPerLeg",
        ColumnDefenitionType.Normal,
        ColDefDataFormats.FloatDoubleDec
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        51,
        "Pay Per TAFB",
        "$/TAFB",
        "TfpPerTafb",
        ColumnDefenitionType.Normal,
        ColDefDataFormats.FloatDoubleDec
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        94,
        "rigADG",
        "rigADG",
        "RigAdgInBp",
        ColumnDefenitionType.Normal,
        ColDefDataFormats.FloatDoubleDec
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        95,
        "rigDHR",
        "rigDHR",
        "RigDhrInBp",
        ColumnDefenitionType.Normal,
        ColDefDataFormats.FloatDoubleDec
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        96,
        "rigDPM",
        "rigDPM",
        "RigDailyMinInBp",
        ColumnDefenitionType.Normal,
        ColDefDataFormats.FloatDoubleDec
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        97,
        "rigTHR",
        "rigTHR",
        "RigTafbInBp",
        ColumnDefenitionType.Normal,
        ColDefDataFormats.FloatDoubleDec
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        52,
        "T234",
        "T234",
        "T234",
        ColumnDefenitionType.Normal,
        ColDefDataFormats.FourDigit
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        53,
        "TAFB",
        "TAFB",
        "TafbInLine",
        ColumnDefenitionType.Normal,
        ColDefDataFormats.TimeTotHours
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        54,
        "Trips",
        "Trips",
        "TotPairings",
        ColumnDefenitionType.Normal,
        ColDefDataFormats.Number
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        93,
        "Trip Tfp",
        "TripTfp",
        "TripTfp",
        ColumnDefenitionType.Normal,
        ColDefDataFormats.FloatDoubleDec
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        55,
        "Vac+LG",
        "Vac+LG",
        "VacPlusRig",
        ColumnDefenitionType.Normal,
        ColDefDataFormats.FloatDoubleDec
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        56,
        "Weekends",
        "Wknds",
        "Weekend",
        ColumnDefenitionType.Normal,
        ColDefDataFormats.Number
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        57,
        "Work All",
        "Work All",
        "DaysWorkInLine",
        ColumnDefenitionType.Normal,
        ColDefDataFormats.Number
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        64,
        "Work BP",
        "Work BP",
        "DaysWork",
        ColumnDefenitionType.Normal,
        ColDefDataFormats.Number
      )
    );
    lstDefaultColumnData.Add(
      new ColumnDefintion(
        85,
        "WorkBlocks Count",
        "wkBlks",
        "WorkBlockListCount",
        ColumnDefenitionType.Normal,
        ColDefDataFormats.Number
      )
    );
    return lstDefaultColumnData;
  };

  /**
   * @method getFilterPopUpData - Hard Coded Filter Pop-Up properties
   */
  public getFilterPopUpData = (): FilterPopUpData[] => {
    const filterData: FilterPopUpData[] = [
      {
        Id: 73,
        VacationType: 2, //Vacation Wbidmax
        FilterName: "Vacation",
        DisplayName: "WBidmax",
        Children: [
          {
            Id: 74,
            VacationType: 2,
            FilterName: "vTotalPay",
            DisplayName: "Total Pay",
            FilterType: "doubleVac",
            Children: null,
          },
          {
            Id: 75,
            VacationType: 2,
            FilterName: "vFlyPay",
            DisplayName: "Fly Pay",
            FilterType: "doubleVac",
            Children: null,
          },
          {
            Id: 76,
            VacationType: 2,
            FilterName: "vVacPay",
            DisplayName: "VA Pay",
            FilterType: "doubleVac",
            Children: null,
          },
          {
            Id: 77,
            VacationType: 2,
            FilterName: "v$/blk",
            DisplayName: "Pay per Block",
            FilterType: "doubleVac",
            Children: null,
          },
          {
            Id: 78,
            VacationType: 2,
            FilterName: "v$/day",
            DisplayName: "Pay per Day",
            FilterType: "doubleVac",
            Children: null,
          },
          {
            Id: 79,
            VacationType: 2,
            FilterName: "vBlk",
            DisplayName: "Block Time",
            FilterType: "doubleVac",
            Children: null,
          },
          {
            Id: 80,
            VacationType: 2,
            FilterName: "vOff",
            DisplayName: "Days Off",
            FilterType: "doubleVac",
            Children: null,
          },
          {
            Id: 81,
            VacationType: 2,
            FilterName: "vVacayLength",
            DisplayName: "Eff. Vac. Length",
            FilterType: "doubleVac",
            Children: null,
          },
          {
            Id: 82,
            VacationType: 2,
            FilterName: "vVOutPay",
            DisplayName: "Carry Out VA Pay",
            FilterType: "doubleVac",
            isVacFAOnly: true,
            Children: null,
          },
        ],
      },
      {
        Id: 82,
        VacationType: 3, //Vacation Swaptimizer
        FilterName: "SWAPtimizer",
        DisplayName: "SWAPtimizer",
        Children: [
          {
            Id: 83,
            VacationType: 3,
            FilterName: "vTotalPay",
            DisplayName: "Total Pay",
            FilterType: "doubleVac",
            Children: null,
            isVacSwapOnly: true,
          },
          {
            Id: 84,
            VacationType: 3,
            FilterName: "vFlyPay",
            DisplayName: "Fly Pay",
            FilterType: "doubleVac",
            Children: null,
            isVacSwapOnly: true,
          },
          {
            Id: 85,
            VacationType: 3,
            FilterName: "vVacPay",
            DisplayName: "VA Pay",
            FilterType: "doubleVac",
            Children: null,
            isVacSwapOnly: true,
          },
          {
            Id: 86,
            VacationType: 3,
            FilterName: "v$/blk",
            DisplayName: "Pay per Block",
            FilterType: "doubleVac",
            Children: null,
            isVacSwapOnly: true,
          },
          {
            Id: 87,
            VacationType: 3,
            FilterName: "v$/day",
            DisplayName: "Pay per Day",
            FilterType: "doubleVac",
            Children: null,
            isVacSwapOnly: true,
          },
          // {
          //   Id: 88,
          //   VacationType: 3,
          //   FilterName: "vCarryPay",
          //   DisplayName: "CarryOut Fly Pay",
          //   FilterType: "doubleVac",
          //   Children: null,
          //   isVacSwapOnly: true
          // },
          {
            Id: 88,
            VacationType: 3,
            FilterName: "vBlk",
            DisplayName: "Block Time",
            FilterType: "doubleVac",
            Children: null,
            isVacSwapOnly: true,
          },
          {
            Id: 89,
            VacationType: 3,
            FilterName: "vOff",
            DisplayName: "Days Off",
            FilterType: "doubleVac",
            Children: null,
            isVacSwapOnly: true,
          },
          {
            Id: 90,
            VacationType: 3,
            FilterName: "vVacayLength",
            DisplayName: "Eff. Vac. Length",
            FilterType: "doubleVac",
            Children: null,
          },
          {
            Id: 91,
            VacationType: 3,
            FilterName: "vLongest",
            DisplayName: "Longest Blk Off",
            FilterType: "doubleVac",
            Children: null,
            isVacSwapOnly: true,
          },
          {
            Id: 92,
            VacationType: 3,
            FilterName: "vVOutPay",
            DisplayName: "Carry Out Fly Pay",
            FilterType: "doubleVac",
            isVacFAOnly: true,
            Children: null,
          },
          {
            Id: 93,
            VacationType: 3,
            FilterName: "vFrontVO",
            DisplayName: "Front VO Pay",
            FilterType: "doubleVac",
            Children: null,
            isVacSwapOnly: true,
          },
          {
            Id: 94,
            VacationType: 3,
            FilterName: "vBackVO",
            DisplayName: "Back VO Pay",
            FilterType: "doubleVac",
            Children: null,
            isVacSwapOnly: true,
          },
        ],
      },
      {
        Id: 107,
        VacationType: 1,
        FilterName: "1 or 2 day off",
        DisplayName: "1 or 2 day off",
        FilterType: "double",
        Children: null,
      },
      {
        Id: 1,
        VacationType: 1,
        FilterName: "Chngs",
        DisplayName: "Aircraft Changes",
        FilterType: "double",
        Children: null,
      },
      {
        Id: 2,
        VacationType: 1,
        FilterName: "Aircraft Types",
        DisplayName: "Aircraft Types",
        Children: [
          {
            Id: 3,
            VacationType: 1,
            FilterName: "700s",
            DisplayName: "Aircraft Type 700",
            FilterType: "double",
            Children: null,
          },
          {
            Id: 4,
            VacationType: 1,
            FilterName: "800s",
            DisplayName: "Aircraft Type 800",
            FilterType: "double",
            Children: null,
          },
          {
            Id: 5,
            VacationType: 1,
            FilterName: "8Max",
            DisplayName: "Aircraft Type 8Max",
            FilterType: "double",
            Children: null,
          },
          {
            Id: 5,
            VacationType: 1,
            FilterName: "7Max",
            DisplayName: "Aircraft Type 7Max",
            FilterType: "double",
            Children: null,
          },
        ],
      },
      {
        Id: 6,
        VacationType: 1,
        FilterName: "BlkOff",
        DisplayName: "Block of Days Off",
        FilterType: "double",
        Children: null,
      },
      {
        Id: 7,
        VacationType: 1,
        FilterName: "BlkHrs",
        DisplayName: "Block Hours",
        FilterType: "double",
        Children: null,
      },
      {
        Id: 8,
        VacationType: 1,
        FilterName: "Cities",
        DisplayName: "Cities",
        Children: [
          {
            Id: 9,
            VacationType: 1,
            FilterName: "OC",
            DisplayName: "Overnight City",
            FilterType: "triple",
            Children: null,
          },
          {
            Id: 10,
            VacationType: 1,
            FilterName: "OCB",
            DisplayName: "Overnight Cities - Bulk",
            FilterType: "bulkCities",
            Children: null,
          },
          {
            Id: 11,
            VacationType: 1,
            FilterName: "LegCty",
            DisplayName: "Leg City",
            FilterType: "triple",
            Children: null,
          },
          {
            Id: 12,
            VacationType: 1,
            FilterName: "NonConLegs",
            DisplayName: "NonConUS Legs",
            FilterType: "double",
            Children: null,
          },
          {
            Id: 13,
            VacationType: 1,
            FilterName: "Regional Overnight Cities",
            DisplayName: "Regional Overnight Cities",
            Children: [
              {
                Id: 14,
                VacationType: 1,
                FilterName: "EC",
                DisplayName: "East Coast",
                FilterType: "multiCity",
                Children: null,
              },
              {
                Id: 15,
                VacationType: 1,
                FilterName: "WC",
                DisplayName: "West Coast",
                FilterType: "multiCity",
                Children: null,
              },
              {
                Id: 16,
                VacationType: 1,
                FilterName: "NonConUS",
                DisplayName: "NonConUS",
                FilterType: "multiCity",
                Children: null,
              },
              {
                Id: 17,
                VacationType: 1,
                FilterName: "AllC",
                DisplayName: "All Cities",
                FilterType: "multiCity",
                Children: null,
              },
              {
                Id: 18,
                VacationType: 1,
                FilterName: "Hawaii",
                DisplayName: "Hawaii",
                FilterType: "multiCity",
                Children: null,
              },
            ],
          },
        ],
      },
      {
        Id: 19,
        VacationType: 1,
        FilterName: "Commuting",
        DisplayName: "Commuting",
        Children: [
          {
            Id: 20,
            VacationType: 1,
            FilterName: "CRqd",
            DisplayName: "Commuting - Manual",
            FilterType: "manual",
            Children: null,
          },
          {
            Id: 21,
            VacationType: 1,
            FilterName: "CmAuto",
            DisplayName: "Commuting - Auto",
            FilterType: "commute-auto",
            Children: null,
          },
        ],
      },
      {
        Id: 22,
        VacationType: 1,
        FilterName: "Days of the Month",
        DisplayName: "Days of the month",
        Children: [
          {
            Id: 23,
            VacationType: 1,
            FilterName: "MonthDays",
            DisplayName: "Days I want off",
            FilterType: "daysOfMonth",
            Children: null,
          },
          {
            Id: 24,
            VacationType: 1,
            FilterName: "WantDays",
            DisplayName: "Days I want to Work",
            FilterType: "daysOfMonth",
            Children: null,
          },
          {
            Id: 25,
            VacationType: 1,
            FilterName: "TripStarts",
            DisplayName: "Days I Don't Want Trips to Start",
            FilterType: "daysOfMonth",
            Children: null,
          },
          {
            Id: 108,
            VacationType: 1,
            FilterName: "TripEnds",
            DisplayName: "Days I Don't Want Trips To End",
            FilterType: "daysOfMonth",
            Children: null,
          },
        ],
      },
      {
        Id: 26,
        VacationType: 1,
        FilterName: "Off",
        DisplayName: "Days off",
        FilterType: "double",
        Children: null,
      },
      {
        Id: 109,
        VacationType: 1,
        FilterName: "reserveDays",
        DisplayName: "Days of Reserve",
        FilterType: "double",
        Children: null,
      },
      {
        Id: 27,
        VacationType: 1,
        FilterName: "Days of Week",
        DisplayName: "Days of Week",
        Children: [
          {
            Id: 28,
            VacationType: 1,
            FilterName: "Wknds",
            DisplayName: "Weekends",
            FilterType: "double",
            Children: null,
          },
          {
            Id: 29,
            VacationType: 1,
            FilterName: "Su",
            DisplayName: "Sundays",
            FilterType: "double",
            Children: null,
          },
          {
            Id: 30,
            VacationType: 1,
            FilterName: "Mo",
            DisplayName: "Mondays",
            FilterType: "double",
            Children: null,
          },
          {
            Id: 31,
            VacationType: 1,
            FilterName: "Tu",
            DisplayName: "Tuesdays",
            FilterType: "double",
            Children: null,
          },
          {
            Id: 32,
            VacationType: 1,
            FilterName: "Wed",
            DisplayName: "Wednesdays",
            FilterType: "double",
            Children: null,
          },
          {
            Id: 33,
            VacationType: 1,
            FilterName: "Th",
            DisplayName: "Thursdays",
            FilterType: "double",
            Children: null,
          },
          {
            Id: 34,
            VacationType: 1,
            FilterName: "Fr",
            DisplayName: "Fridays",
            FilterType: "double",
            Children: null,
          },
          {
            Id: 35,
            VacationType: 1,
            FilterName: "Sa",
            DisplayName: "Saturdays",
            FilterType: "double",
            Children: null,
          },
        ],
      },
      {
        Id: 36,
        VacationType: 1,
        FilterName: "Deadheads",
        DisplayName: "Deadheads",
        Children: [
          {
            Id: 37,
            VacationType: 1,
            FilterName: "DHs",
            DisplayName: "Deadheads",
            FilterType: "double",
            Children: null,
          },
          {
            Id: 38,
            VacationType: 1,
            FilterName: "DH Start",
            DisplayName: "DH At Start To",
            FilterType: "city",
            Children: null,
          },
          {
            Id: 39,
            VacationType: 1,
            FilterName: "DH End",
            DisplayName: "DH At End From",
            FilterType: "city",
            Children: null,
          },
          {
            Id: 40,
            VacationType: 1,
            FilterName: "DH Either",
            DisplayName: "DH At Either",
            FilterType: "city",
            Children: null,
          },
        ],
      },
      {
        Id: 41,
        VacationType: 1,
        FilterName: "Duty Time",
        DisplayName: "Duty Time",
        Children: [
          {
            Id: 42,
            VacationType: 1,
            FilterName: "DtyHrs",
            DisplayName: "Duty Hours",
            FilterType: "double",
            Children: null,
          },
          {
            Id: 43,
            VacationType: 1,
            FilterName: "Dty/Day",
            DisplayName: "Duty Hours Per Day",
            FilterType: "double",
            Children: null,
          },
        ],
      },
      {
        Id: 44,
        VacationType: 1,
        FilterName: "Flags",
        DisplayName: "Flags",
        FilterType: "flagType",
        Children: null,
      },
      {
        Id: 103,
        VacationType: 1,
        FilterName: "Ground Time",
        DisplayName: "Ground Time",
        Children: [
          {
            Id: 104,
            VacationType: 1,
            FilterName: "Ground Time Average",
            DisplayName: "Ground Time Average",
            FilterType: "double",
            Children: null,
          },
          {
            Id: 105,
            VacationType: 1,
            FilterName: "Ground Time Max",
            DisplayName: "Ground Time Max",
            FilterType: "double",
            Children: null,
          },
        ],
      },
      {
        Id: 45,
        VacationType: 1,
        FilterName: "Legs",
        DisplayName: "Legs",
        FilterType: "double",
        Children: null,
      },
      {
        Id: 46,
        VacationType: 1,
        FilterName: "MLegs",
        DisplayName: "Max Legs in a Day",
        FilterType: "double",
        Children: null,
      },
      {
        Id: 47,
        VacationType: 1,
        FilterName: "Overlap Days",
        DisplayName: "Overlap Days",
        Children: [
          {
            Id: 48,
            VacationType: 1,
            FilterName: "StartOLap",
            DisplayName: "Month Start Overlap",
            FilterType: "double",
            Children: null,
          },
          {
            Id: 49,
            VacationType: 1,
            FilterName: "EndOLap",
            DisplayName: "Month End Overlap",
            FilterType: "double",
            Children: null,
          },
        ],
      },
      {
        Id: 106,
        VacationType: 1,
        FilterName: "OvAvg",
        DisplayName: "Overnight Average",
        FilterType: "double",
        Children: null,
      },
      {
        Id: 50,
        VacationType: 1,
        FilterName: "OLength",
        DisplayName: "Overnight Length",
        FilterType: "double",
        Children: null,
      },
      {
        Id: 51,
        VacationType: 1,
        FilterName: "OIBs",
        DisplayName: "Overnights in Base",
        FilterType: "double",
        Children: null,
      },
      {
        Id: 52,
        VacationType: 1,
        FilterName: "Passes Through Base",
        DisplayName: "Passes Through Base",
        Children: [
          {
            Id: 53,
            VacationType: 1,
            FilterName: "PTBs",
            DisplayName: "Passes Through Base",
            FilterType: "double",
            Children: null,
          },
          {
            Id: 54,
            VacationType: 1,
            FilterName: "MidPTBs",
            DisplayName: "Mid-Trip PTBs",
            FilterType: "double",
            Children: null,
          },
        ],
      },
      {
        Id: 55,
        VacationType: 1,
        FilterName: "Pay",
        DisplayName: "Pay",
        Children: [
          {
            Id: 56,
            VacationType: 1,
            FilterName: "Pay",
            DisplayName: "Pay",
            FilterType: "double",
            Children: null,
          },
          {
            Id: 57,
            VacationType: 1,
            FilterName: "$/Blk",
            DisplayName: "Pay Per Block Hour",
            FilterType: "double",
            Children: null,
          },
          {
            Id: 58,
            VacationType: 1,
            FilterName: "$/Day",
            DisplayName: "Pay Per Day",
            FilterType: "double",
            Children: null,
          },
          {
            Id: 59,
            VacationType: 1,
            FilterName: "$/Duty",
            DisplayName: "Pay Per Duty Hour",
            FilterType: "double",
            Children: null,
          },
          {
            Id: 60,
            VacationType: 1,
            FilterName: "$/Leg",
            DisplayName: "Pay Per Leg",
            FilterType: "double",
            Children: null,
          },
          {
            Id: 61,
            VacationType: 1,
            FilterName: "$/Tafb",
            DisplayName: "Pay Per TAFB",
            FilterType: "double",
            Children: null,
          },
          {
            Id: 62,
            VacationType: 1,
            FilterName: "CoPay",
            DisplayName: "Carry Out Pay",
            FilterType: "double",
            Children: null,
          },
          {
            Id: 63,
            VacationType: 1,
            FilterName: "Line Rig",
            DisplayName: "Line Rig",
            FilterType: "double",
            Children: null,
          },
        ],
      },
      {
        Id: 111,
        VacationType: 1,
        FilterName: "PDO",
        DisplayName: "PDO",
        FilterType: "PDO",
        Children: null,
      },
      {
        Id: 110,
        VacationType: 1,
        FilterName: "RedEyeTrips",
        DisplayName: "Red Eye Trips",
        FilterType: "double",
        Children: null,
      },
      {
        Id: 64,
        VacationType: 1,
        FilterName: "Report-Release",
        DisplayName: "Report-Release",
        FilterType: "report-release",
        Children: null,
      },
      {
        Id: 65,
        VacationType: 1,
        FilterName: "TAFB",
        DisplayName: "TAFB Hours",
        FilterType: "double",
        Children: null,
      },
      {
        Id: 66,
        VacationType: 1,
        FilterName: "Trips",
        DisplayName: "Number of Trips",
        FilterType: "double",
        Children: null,
      },
      {
        Id: 67,
        VacationType: 1,
        FilterName: "Trip Length",
        DisplayName: "Trip Length",
        Children: [
          {
            Id: 68,
            VacationType: 1,
            FilterName: "Turns",
            DisplayName: "Turns",
            FilterType: "double",
            Children: null,
          },
          {
            Id: 69,
            VacationType: 1,
            FilterName: "2Days",
            DisplayName: "Two Day Trips",
            FilterType: "double",
            Children: null,
          },
          {
            Id: 70,
            VacationType: 1,
            FilterName: "3Days",
            DisplayName: "Three Day Trips",
            FilterType: "double",
            Children: null,
          },
          {
            Id: 71,
            VacationType: 1,
            FilterName: "4Days",
            DisplayName: "Four Day Trips",
            FilterType: "double",
            Children: null,
          },
        ],
      },
      {
        Id: 94,
        VacationType: 1,
        FilterName: "workBlock",
        DisplayName: "WorkBlocks",
        FilterType: "triple",
        Children: null,
      },
      {
        Id: 95,
        VacationType: 1,
        FilterName: "wrkBlkCount",
        DisplayName: "WorkBlocks Count",
        FilterType: "double",
        Children: null,
      },
      {
        Id: 72,
        VacationType: 1,
        FilterName: "Work",
        DisplayName: "Workdays",
        FilterType: "double",
        Children: null,
      },
    ];
    return filterData;
  };

  /**
   * @method getDefaultFilterSort for getting default filter and sort
   */
  public getDefaultFilterSort = (): CrewbidState => {
    const returnVal: CrewbidState[] = [
      {
        lstFilters: [
          {
            title: "Aircraft Changes",
            Listfilter: [
              {
                Abbreviation: "Chngs",
                Category: 6,
                Comparison: 1,
                KeyPath: "numAircraftChanges",
                Name: "Aircraft Changes",
                Type: "1",
                Variable: <Key1>{
                  RANGESTART: 0,
                  RANGEEND: 16,
                  VALUE: "1",
                },
              },
            ],
          },
          {
            title: "Aircraft Types",
            Listfilter: [
              {
                Abbreviation: "700s",
                Category: 7,
                Comparison: 1,
                KeyPath: "aircraftType700Count",
                Name: "Aircraft Type 700",
                Type: "2",
                Variable: <Key1>{
                  RANGESTART: 0,
                  RANGEEND: 40,
                  VALUE: "0",
                },
              },
              {
                Abbreviation: "800s",
                Category: 7,
                Comparison: 1,
                KeyPath: "aircraftType800Count",
                Name: "Aircraft Type 800",
                Type: "3",
                Variable: <Key1>{
                  RANGESTART: 0,
                  RANGEEND: 40,
                  VALUE: "0",
                },
              },
              {
                Abbreviation: "8Max",
                Category: 7,
                Comparison: 1,
                KeyPath: "aircraftType8MaxCount",
                Name: "Aircraft Type 8MAX",
                Type: "5",
                Variable: <Key1>{
                  RANGESTART: 0,
                  RANGEEND: 40,
                  VALUE: "0",
                },
              },
              {
                Abbreviation: "7Max",
                Category: 7,
                Comparison: 1,
                KeyPath: "aircraftType7MaxCount",
                Name: "Aircraft Type 7MAX",
                Type: "6",
                Variable: <Key1>{
                  RANGESTART: 0,
                  RANGEEND: 40,
                  VALUE: "0",
                },
              },
            ],
          },
          {
            title: "Block of Days Off",
            Listfilter: [
              {
                Abbreviation: "BlkOff",
                Category: 8,
                Comparison: 3,
                KeyPath: "blockOfDaysOff",
                Name: "Block of Days Off",
                Type: "3",
                Variable: <Key1>{
                  RANGESTART: 1,
                  RANGEEND: 28,
                  VALUE: "1",
                },
              },
            ],
          },
          {
            title: "Block Hours",
            Listfilter: [
              {
                Abbreviation: "BlkHrs",
                Category: 9,
                Comparison: 3,
                KeyPath: "blockHours",
                Name: "Block Hours",
                Type: "3",
                Variable: <Key1>{
                  RANGESTART: 0,
                  RANGEEND: 90,
                  VALUE: "70",
                },
              },
            ],
          },
          {
            title: "Cities",
            Listfilter: [
              {
                Abbreviation: "OC",
                Category: 10,
                Comparison: 3,
                KeyPath: "",
                Name: "Overnight City",
                Type: "0",
                Variable: <Key2>{
                  CITY: "",
                  RANGESTART: 0,
                  RANGEEND: 15,
                  VALUE: "1",
                },
              },
              {
                Abbreviation: "LegCty",
                Category: 10,
                Comparison: 1,
                KeyPath: "",
                Name: "Leg City",
                Type: "1",
                Variable: <Key2>{
                  CITY: "",
                  RANGESTART: 0,
                  RANGEEND: 15,
                  VALUE: "1",
                },
              },
              {
                Abbreviation: "OCB",
                Category: 34,
                Comparison: 1,
                KeyPath: "",
                Name: "Overnight Cities - Bulk",
                Type: "0",
                Variable: <OverNightCityState>{
                  OverNightYes: [],
                  OverNightNo: [],
                },
              },
              {
                Abbreviation: "NonConLegs",
                Category: 10,
                Comparison: 1,
                KeyPath: "nonConusLegsCount",
                Name: "NonConUS Legs",
                Type: "7",
                Variable: <Key2>{
                  CITY: "",
                  RANGESTART: 0,
                  RANGEEND: 15,
                  VALUE: "1",
                },
              },
            ],
          },
          {
            title: "Regional Overnight Cities",
            Listfilter: [
              {
                Abbreviation: "EC",
                Category: 10,
                Comparison: 3,
                KeyPath: "",
                Name: "East Coast",
                Type: "2",
                Variable: <Key2>{
                  CITY: "",
                  RANGESTART: 0,
                  RANGEEND: 15,
                  VALUE: "1",
                },
              },
              {
                Abbreviation: "WC",
                Category: 10,
                Comparison: 1,
                KeyPath: "",
                Name: "West Coast",
                Type: "3",
                Variable: <Key2>{
                  CITY: "",
                  RANGESTART: 0,
                  RANGEEND: 15,
                  VALUE: "1",
                },
              },
              {
                Abbreviation: "NonConUS",
                Category: 10,
                Comparison: 1,
                KeyPath: "",
                Name: "NonConUS",
                Type: "5",
                Variable: <Key2>{
                  CITY: "",
                  RANGESTART: 0,
                  RANGEEND: 15,
                  VALUE: "1",
                },
              },
              {
                Abbreviation: "AllC",
                Category: 10,
                Comparison: 1,
                KeyPath: "",
                Name: "All Cities",
                Type: "6",
                Variable: <Key2>{
                  CITY: "",
                  RANGESTART: 0,
                  RANGEEND: 15,
                  VALUE: "1",
                },
              },
              {
                Abbreviation: "Hawaii",
                Category: 10,
                Comparison: 1,
                KeyPath: "",
                Name: "Hawaii",
                Type: "8",
                Variable: <Key2>{
                  CITY: "",
                  RANGESTART: 0,
                  RANGEEND: 15,
                  VALUE: "1",
                },
              },
            ],
          },
          {
            title: "Days Off",
            Listfilter: [
              {
                Abbreviation: "Off",
                Category: 14,
                Comparison: 3,
                KeyPath: "daysOff",
                Name: "Days Off",
                Type: "3",
                Variable: <Key1>{
                  RANGESTART: 5,
                  RANGEEND: 31,
                  VALUE: "5",
                },
              },
            ],
          },
          {
            title: "Days of Reserve",
            Listfilter: [
              {
                Abbreviation: "reserveDays",
                Category: 45,
                Comparison: 3,
                KeyPath: "reserveDays",
                Name: "Days of Reserve",
                Type: "1",
                Variable: <Key1>{
                  RANGESTART: 1,
                  RANGEEND: 30,
                  VALUE: "5",
                },
              },
            ],
          },
          {
            title: "Days of Week",
            Listfilter: [
              {
                Abbreviation: "Wknds",
                Category: 5,
                Comparison: 1,
                KeyPath: "weekendsCount",
                Name: "Weekends",
                Type: "1",
                Variable: <Key1>{
                  RANGESTART: 0,
                  RANGEEND: 15,
                  VALUE: "1",
                },
              },
              {
                Abbreviation: "Su",
                Category: 5,
                Comparison: 1,
                KeyPath: "sundaysCount",
                Name: "Sundays",
                Type: "1",
                Variable: <Key1>{
                  RANGESTART: 0,
                  RANGEEND: 15,
                  VALUE: "1",
                },
              },
              {
                Abbreviation: "Mo",
                Category: 5,
                Comparison: 1,
                KeyPath: "mondaysCount",
                Name: "Mondays",
                Type: "1",
                Variable: <Key1>{
                  RANGESTART: 0,
                  RANGEEND: 15,
                  VALUE: "1",
                },
              },
              {
                Abbreviation: "Tu",
                Category: 5,
                Comparison: 1,
                KeyPath: "tuesdaysCount",
                Name: "Tuesdays",
                Type: "1",
                Variable: <Key1>{
                  RANGESTART: 0,
                  RANGEEND: 15,
                  VALUE: "1",
                },
              },
              {
                Abbreviation: "Wed",
                Category: 5,
                Comparison: 1,
                KeyPath: "wednesdaysCount",
                Name: "Wednesdays",
                Type: "1",
                Variable: <Key1>{
                  RANGESTART: 0,
                  RANGEEND: 15,
                  VALUE: "1",
                },
              },
              {
                Abbreviation: "Th",
                Category: 5,
                Comparison: 1,
                KeyPath: "thursdaysCount",
                Name: "Thursdays",
                Type: "1",
                Variable: <Key1>{
                  RANGESTART: 0,
                  RANGEEND: 15,
                  VALUE: "1",
                },
              },
              {
                Abbreviation: "Fr",
                Category: 5,
                Comparison: 1,
                KeyPath: "fridaysCount",
                Name: "Fridays",
                Type: "1",
                Variable: <Key1>{
                  RANGESTART: 0,
                  RANGEEND: 15,
                  VALUE: "1",
                },
              },
              {
                Abbreviation: "Sa",
                Category: 5,
                Comparison: 1,
                KeyPath: "saturdaysCount",
                Name: "Saturdays",
                Type: "1",
                Variable: <Key1>{
                  RANGESTART: 0,
                  RANGEEND: 15,
                  VALUE: "1",
                },
              },
            ],
          },
          {
            title: "Legs",
            Listfilter: [
              {
                Abbreviation: "Legs",
                Category: 19,
                Comparison: 1,
                KeyPath: "numLegs",
                Name: "Legs",
                Type: "1",
                Variable: <Key1>{
                  RANGESTART: 0,
                  RANGEEND: 60,
                  VALUE: "30",
                },
              },
            ],
          },
          {
            title: "Max Legs in a Day",
            Listfilter: [
              {
                Abbreviation: "MLegs",
                Category: 20,
                Comparison: 1,
                KeyPath: "maxLegsInADay",
                Name: "Max Legs in a Day",
                Type: "1",
                Variable: <Key1>{
                  RANGESTART: 1,
                  RANGEEND: 15,
                  VALUE: "3",
                },
              },
            ],
          },
          {
            title: "Overnights in Base",
            Listfilter: [
              {
                Abbreviation: "OIBs",
                Category: 22,
                Comparison: 1,
                KeyPath: "overnightsInBase",
                Name: "Overnights in Base",
                Type: "1",
                Variable: <Key1>{
                  RANGESTART: 0,
                  RANGEEND: 11,
                  VALUE: "0",
                },
              },
            ],
          },
          {
            title: "Passes Through Base",
            Listfilter: [
              {
                Abbreviation: "PTBs",
                Category: 23,
                Comparison: 1,
                KeyPath: "passesThruBase",
                Name: "Passes Through Base",
                Type: "1",
                Variable: <Key1>{
                  RANGESTART: 0,
                  RANGEEND: 10,
                  VALUE: "0",
                },
              },
              {
                Abbreviation: "MidPTBs",
                Category: 23,
                Comparison: 1,
                KeyPath: "midTripPTBs",
                Name: "Mid-Trip PTBs",
                Type: "1",
                Variable: <Key1>{
                  RANGESTART: 0,
                  RANGEEND: 10,
                  VALUE: "0",
                },
              },
            ],
          },
          {
            title: "TAFB Hours",
            Listfilter: [
              {
                Abbreviation: "TAFB",
                Category: 25,
                Comparison: 1,
                KeyPath: "tafbHours",
                Name: "TAFB Hours",
                Type: "1",
                Variable: <Key1>{
                  RANGESTART: 0,
                  RANGEEND: 280,
                  VALUE: "205",
                },
              },
            ],
          },
          {
            title: "Number of Trips",
            Listfilter: [
              {
                Abbreviation: "Trips",
                Category: 26,
                Comparison: 1,
                KeyPath: "numTrips",
                Name: "Number of Trips",
                Type: "1",
                Variable: <Key1>{
                  RANGESTART: 0,
                  RANGEEND: 19,
                  VALUE: "4",
                },
              },
            ],
          },
          {
            title: "Trip Length",
            Listfilter: [
              {
                Abbreviation: "Turns",
                Category: 5,
                Comparison: 1,
                KeyPath: "turnsCount",
                Name: "Turns",
                Type: "1",
                Variable: <Key1>{
                  RANGESTART: 0,
                  RANGEEND: 15,
                  VALUE: "1",
                },
              },
              {
                Abbreviation: "2Days",
                Category: 5,
                Comparison: 1,
                KeyPath: "twoDayTripsCount",
                Name: "Two Day Trips",
                Type: "1",
                Variable: <Key1>{
                  RANGESTART: 0,
                  RANGEEND: 15,
                  VALUE: "1",
                },
              },
              {
                Abbreviation: "3Days",
                Category: 5,
                Comparison: 1,
                KeyPath: "threeDayTripsCount",
                Name: "Three Day Trips",
                Type: "1",
                Variable: <Key1>{
                  RANGESTART: 0,
                  RANGEEND: 15,
                  VALUE: "1",
                },
              },
              {
                Abbreviation: "4Days",
                Category: 5,
                Comparison: 1,
                KeyPath: "fourDayTripsCount",
                Name: "Four Day Trips",
                Type: "1",
                Variable: <Key1>{
                  RANGESTART: 0,
                  RANGEEND: 15,
                  VALUE: "1",
                },
              },
            ],
          },
          {
            title: "Work Days",
            Listfilter: [
              {
                Abbreviation: "Work",
                Category: 27,
                Comparison: 1,
                KeyPath: "workDays",
                Name: "Workdays",
                Type: "1",
                Variable: <Key1>{
                  RANGESTART: 0,
                  RANGEEND: 20,
                  VALUE: "12",
                },
              },
            ],
          },
          {
            title: "Flags",
            Listfilter: [
              {
                Abbreviation: "Flags",
                Category: 32,
                Comparison: 5,
                KeyPath: "nil",
                Name: "Flags",
                Type: "0",
                Variable: this.getFlagColorsList().map((x) => x.order),
              },
            ],
          },
          {
            title: "Days of the Month",
            Listfilter: [
              {
                Abbreviation: "MonthDays",
                Category: 13,
                Comparison: 0,
                KeyPath: "nil",
                Name: "Days I Want Off",
                Type: "0",
                Variable: [],
              },
              {
                Abbreviation: "WantDays",
                Category: 13,
                Comparison: 0,
                KeyPath: "nil",
                Name: "Days I Want To Work",
                Type: "1",
                Variable: [],
              },
              {
                Abbreviation: "TripStarts",
                Category: 13,
                Comparison: 0,
                KeyPath: "nil",
                Name: "Days I Don't Want Trips To Start",
                Type: "2",
                Variable: [],
              },
              {
                Abbreviation: "TripEnds",
                Category: 13,
                Comparison: 0,
                KeyPath: "nil",
                Name: "Days I Don't Want Trips To End",
                Type: "3",
                Variable: [],
              },
            ],
          },
          {
            title: "Duty Time",
            Listfilter: [
              {
                Abbreviation: "DtyHrs",
                Category: 16,
                Comparison: 1,
                KeyPath: "dutyHours",
                Name: "Duty Hours",
                Type: "1",
                Variable: <Key1>{
                  RANGESTART: 0,
                  RANGEEND: 126,
                  VALUE: "100",
                },
              },
              {
                Abbreviation: "Dty/Day",
                Category: 16,
                Comparison: 1,
                KeyPath: "dutyHoursPerDay",
                Name: "Duty Hours Per Day",
                Type: "2",
                Variable: <Key5>{
                  RANGESTART: 5.0,
                  RANGEEND: 10.0,
                  VALUE: "8.0",
                  STEP: 0.1,
                  DECIMAL: true,
                  NUMPLACES: 1,
                },
              },
            ],
          },
          {
            title: "Pay",
            Listfilter: [
              {
                Abbreviation: "Pay",
                Category: 24,
                Comparison: 3,
                KeyPath: "pay",
                Name: "Pay",
                Type: "0",
                Variable: <Key1>{
                  RANGESTART: 50,
                  RANGEEND: 110,
                  VALUE: "80",
                },
              },
              {
                Abbreviation: "$/Blk",
                Category: 24,
                Comparison: 3,
                KeyPath: "payPerBlockHour",
                Name: "Pay Per Block Hour",
                Type: "1",
                Variable: <Key5>{
                  RANGESTART: 1.1,
                  RANGEEND: 2.0,
                  VALUE: "1.30",
                  STEP: 0.01,
                  DECIMAL: true,
                  NUMPLACES: 2,
                },
              },
              {
                Abbreviation: "$/Day",
                Category: 24,
                Comparison: 3,
                KeyPath: "payPerDay",
                Name: "Pay Per Day",
                Type: "2",
                Variable: <Key5>{
                  RANGESTART: 5.0,
                  RANGEEND: 9.0,
                  VALUE: "7.5",
                  STEP: 0.1,
                  DECIMAL: true,
                  NUMPLACES: 1,
                },
              },
              {
                Abbreviation: "$/Duty",
                Category: 24,
                Comparison: 3,
                KeyPath: "payPerDutyTime",
                Name: "Pay Per Duty Hour",
                Type: "3",
                Variable: <Key5>{
                  RANGESTART: 0.6,
                  RANGEEND: 1.0,
                  VALUE: "0.80",
                  STEP: 0.01,
                  DECIMAL: true,
                  NUMPLACES: 2,
                },
              },
              {
                Abbreviation: "$/Leg",
                Category: 24,
                Comparison: 3,
                KeyPath: "payPerLeg",
                Name: "Pay Per Leg",
                Type: "4",
                Variable: <Key5>{
                  RANGESTART: 1.0,
                  RANGEEND: 3.0,
                  VALUE: "2.0",
                  STEP: 0.1,
                  DECIMAL: true,
                  NUMPLACES: 1,
                },
              },
              {
                Abbreviation: "$/Tafb",
                Category: 24,
                Comparison: 3,
                KeyPath: "payPerTAFB",
                Name: "Pay Per TAFB",
                Type: "5",
                Variable: <Key5>{
                  RANGESTART: 0.2,
                  RANGEEND: 0.6,
                  VALUE: "0.40",
                  STEP: 0.01,
                  DECIMAL: true,
                  NUMPLACES: 2,
                },
              },
              {
                Abbreviation: "CoPay",
                Category: 24,
                Comparison: 3,
                KeyPath: "carryOutPay",
                Name: "Carry Out Pay",
                Type: "6",
                Variable: <Key1>{
                  RANGESTART: 0,
                  RANGEEND: 30,
                  VALUE: "0",
                },
              },
              {
                Abbreviation: "Line Rig",
                Category: 24,
                Comparison: 3,
                KeyPath: "lineRig",
                Name: "Line Rig",
                Type: "0",
                Variable: <Key1>{
                  RANGESTART: 0,
                  RANGEEND: 80,
                  VALUE: "80",
                },
              },
            ],
          },
          {
            title: "Commuting",
            Listfilter: [
              {
                Abbreviation: "CRqd",
                Category: 12,
                Comparison: 1,
                KeyPath: "",
                Name: "Commuting - Manual",
                Type: "0",
                Variable: <CommutingManual>{
                  RANGESTART: "0",
                  RANGEEND: "10",
                  VALUE: "0",
                  MON_THURS_DEPART: "0",
                  MON_THURS_RETURN: "0",
                  FRI_DEPART: "0",
                  FRI_RETURN: "0",
                  SAT_DEPART: "0",
                  SAT_RETURN: "0",
                  SUN_DEPART: "0",
                  SUN_RETURN: "0",
                  NoMidCheckState: true,
                },
              },
              {
                Abbreviation: "CmAuto",
                Category: 33,
                Comparison: 1,
                KeyPath: "",
                Name: "Commuting - Auto",
                Type: "0",
                Variable: <CommutingAuto>{
                  commuteCity: "",
                  selectedConnectTime: "",
                  nonStop: false,
                  selectedTakeOffPadTimeValues: "",
                  selectedBackToBasePadTimeValues: "",
                  nMid: 0,
                  cmtFrBaOv: 3,
                  cmtGreaterOrLesser: 0,
                  cmtPercentage: "",
                },
              },
            ],
          },
          {
            title: "Overlap Days",
            Listfilter: [
              {
                Abbreviation: "StartOLap",
                Category: 21,
                Comparison: 3,
                KeyPath: "startDay",
                Name: "Month Start Overlap",
                Type: "0",
                Variable: <Key1>{
                  RANGESTART: 0,
                  RANGEEND: 15,
                  VALUE: "3",
                },
              },
              {
                Abbreviation: "EndOLap",
                Category: 21,
                Comparison: 1,
                KeyPath: "overlapDaysCount",
                Name: "Month End Overlap",
                Type: "1",
                Variable: <Key1>{
                  RANGESTART: 0,
                  RANGEEND: 10,
                  VALUE: "0",
                },
              },
            ],
          },
          {
            title: "Overnight Average",
            Listfilter: [
              {
                Abbreviation: "OvAvg",
                Category: 43,
                Comparison: 3,
                KeyPath: "ovAvg",
                Name: "Overnight Average",
                Type: "1",
                Variable: <Key1>{
                  RANGESTART: 0,
                  RANGEEND: 31,
                  VALUE: "15",
                },
              },
            ],
          },
          {
            title: "Overnight Length",
            Listfilter: [
              {
                Abbreviation: "OLength",
                Category: 28,
                Comparison: 3,
                KeyPath: "",
                Name: "Overnight Length",
                Type: "0",
                Variable: <Key1>{
                  RANGESTART: 9,
                  RANGEEND: 47,
                  VALUE: "12",
                },
              },
            ],
          },
          {
            title: "Deadheads",
            Listfilter: [
              {
                Abbreviation: "DHs",
                Category: 15,
                Comparison: 1,
                KeyPath: "deadheadsCount",
                Name: "Deadheads",
                Type: "0",
                Variable: <Key1>{
                  RANGESTART: 0,
                  RANGEEND: 10,
                  VALUE: "1",
                },
              },
              {
                Abbreviation: "DH Start",
                Category: 15,
                Comparison: 3,
                KeyPath: "deadheadsAtStartCount",
                Name: "DH At Start To",
                Type: "1",
                Variable: <Key2>{
                  CITY: "",
                  RANGESTART: 0,
                  RANGEEND: 10,
                  VALUE: "1",
                },
              },
              {
                Abbreviation: "DH End",
                Category: 15,
                Comparison: 3,
                KeyPath: "deadheadsAtEndCount",
                Name: "DH At End From",
                Type: "2",
                Variable: <Key2>{
                  CITY: "",
                  RANGESTART: 0,
                  RANGEEND: 10,
                  VALUE: "1",
                },
              },
              {
                Abbreviation: "DH Either",
                Category: 15,
                Comparison: 3,
                KeyPath: "deadheadsAtEitherCount",
                Name: "DH At Either",
                Type: "3",
                Variable: <Key2>{
                  CITY: "",
                  RANGESTART: 0,
                  RANGEEND: 10,
                  VALUE: "1",
                },
              },
            ],
          },
          {
            title: "Vacation",
            Listfilter: [
              {
                Abbreviation: "vTotalPay",
                Category: 31,
                Comparison: 3,
                KeyPath: "vTotalPay",
                Name: "Total Pay",
                Type: "0",
                Variable: <Key1>{
                  RANGESTART: 50,
                  RANGEEND: 130,
                  VALUE: "80",
                },
              },
              {
                Abbreviation: "vFlyPay",
                Category: 31,
                Comparison: 3,
                KeyPath: "vFlyPay",
                Name: "Fly Pay",
                Type: "1",
                Variable: <Key1>{
                  RANGESTART: 70,
                  RANGEEND: 110,
                  VALUE: "70",
                },
              },
              {
                Abbreviation: "vVacPay",
                Category: 31,
                Comparison: 3,
                KeyPath: "vVacationPay",
                Name: "Vacation Pay",
                Type: "2",
                Variable: <Key1>{
                  RANGESTART: 5,
                  RANGEEND: 85,
                  VALUE: "26",
                },
              },
              {
                Abbreviation: "v$/blk",
                Category: 31,
                Comparison: 3,
                KeyPath: "vPayPerBlock",
                Name: "Pay Per Block",
                Type: "3",
                Variable: <Key1>{
                  RANGESTART: 26,
                  RANGEEND: 60,
                  VALUE: "26",
                },
              },
              {
                Abbreviation: "v$/day",
                Category: 31,
                Comparison: 3,
                KeyPath: "vPayPerDay",
                Name: "Pay Per Day",
                Type: "4",
                Variable: <Key1>{
                  RANGESTART: 10,
                  RANGEEND: 60,
                  VALUE: "26",
                },
              },
              {
                Abbreviation: "vBlk",
                Category: 31,
                Comparison: 1,
                KeyPath: "vBlockTime",
                Name: "Block Time",
                Type: "6",
                Variable: <Key1>{
                  RANGESTART: 1,
                  RANGEEND: 90,
                  VALUE: "30",
                },
              },
              {
                Abbreviation: "vOff",
                Category: 31,
                Comparison: 3,
                KeyPath: "vDaysOff",
                Name: "Days Off",
                Type: "7",
                Variable: <Key1>{
                  RANGESTART: 10,
                  RANGEEND: 31,
                  VALUE: "20",
                },
              },
              {
                Abbreviation: "vVacayLength",
                Category: 29,
                Comparison: 3,
                KeyPath: "vEffectiveVacayLength",
                Name: "Eff. Vac. Length",
                Type: "8",
                Variable: <Key1>{
                  RANGESTART: 7,
                  RANGEEND: 25,
                  VALUE: "10",
                },
              },
              {
                Abbreviation: "vVOutPay",
                Category: 31,
                Comparison: 3,
                KeyPath: "vVacayCarryOutPay",
                Name: "Carry Out VA Pay",
                Type: "9",
                Variable: <Key1>{
                  RANGESTART: 5,
                  RANGEEND: 30,
                  VALUE: "10",
                },
              },
            ],
          },
          {
            title: "Report-Release",
            Listfilter: [
              {
                Abbreviation: "Report-Release",
                Category: 37,
                Comparison: 2,
                KeyPath: "reportRelease",
                Name: "Report-Release",
                Type: "0",
                Variable: <ReportRelease>{
                  selectedOption: 0,
                  reportValue: "",
                  releaseValue: "",
                  isFirst: false,
                  isLast: false,
                  isNoMid: false,
                  selectedIndex: {},
                },
              },
            ],
          },
          {
            title: "RedEyeTrips",
            Listfilter: [
              {
                Abbreviation: "RedEyeTrips",
                Category: 46,
                Comparison: 1,
                KeyPath: "redEyeTrips",
                Name: "RedEyeTrips",
                Type: "1",
                Variable: <Key1>{
                  RANGESTART: 0,
                  RANGEEND: 16,
                  VALUE: "1",
                },
              },
            ],
          },
          {
            title: "PDO",
            Listfilter: [
              {
                Abbreviation: "PDO",
                Category: 47,
                Comparison: 1,
                KeyPath: "pdo",
                Name: "PDO",
                Type: "2",
                Variable: <KeyPDO>{
                  RANGESTART: 180,
                  RANGEEND: 1620,
                  VALUE: "915",
                  STEP: 15,
                  CITY: "Any Cities",
                  DAY: "Any Days"
                },
              },
            ],
          },
          {
            title: "WorkBlocks",
            Listfilter: [
              {
                Abbreviation: "workBlock",
                Category: 39,
                Comparison: 1,
                KeyPath: "workBlock3",
                Name: "WorkBlocks",
                Type: "1",
                Variable: <Key1>{
                  RANGESTART: 0,
                  RANGEEND: 10,
                  VALUE: "0",
                },
              },
            ],
          },
          {
            title: "WorkBlocks Count",
            Listfilter: [
              {
                Abbreviation: "wrkBlkCount",
                Category: 40,
                Comparison: 1,
                KeyPath: "workBlockCount",
                Name: "WorkBlocks Count",
                Type: "1",
                Variable: <Key1>{
                  RANGESTART: 0,
                  RANGEEND: 16,
                  VALUE: "1",
                },
              },
            ],
          },
          {
            title: "1 or 2 day off",
            Listfilter: [
              {
                Abbreviation: "1 or 2 day off",
                Category: 44,
                Comparison: 1,
                KeyPath: "oneOrTwoDaysCount",
                Name: "1 or 2 day off",
                Type: "1",
                Variable: <Key1>{
                  RANGESTART: 0,
                  RANGEEND: 11,
                  VALUE: "1",
                },
              },
            ],
          },
          {
            title: "SWAPtimizer",
            Listfilter: [
              {
                Abbreviation: "vTotalPay",
                Category: 29,
                Comparison: 3,
                KeyPath: "vTotalPay",
                Name: "Total Pay",
                Type: "0",
                Variable: <Key1>{
                  RANGESTART: 50,
                  RANGEEND: 130,
                  VALUE: "80",
                },
              },
              {
                Abbreviation: "vFlyPay",
                Category: 29,
                Comparison: 3,
                KeyPath: "vFlyPay",
                Name: "Fly Pay",
                Type: "1",
                Variable: <Key1>{
                  RANGESTART: 70,
                  RANGEEND: 110,
                  VALUE: "70",
                },
              },
              {
                Abbreviation: "vVacPay",
                Category: 29,
                Comparison: 3,
                KeyPath: "vVacationPay",
                Name: "VA Pay",
                Type: "2",
                Variable: <Key1>{
                  RANGESTART: 5,
                  RANGEEND: 85,
                  VALUE: "26",
                },
              },
              {
                Abbreviation: "v$/blk",
                Category: 29,
                Comparison: 3,
                KeyPath: "vPayPerBlock",
                Name: "Pay Per Block",
                Type: "3",
                Variable: <Key1>{
                  RANGESTART: 26,
                  RANGEEND: 60,
                  VALUE: "26",
                },
              },
              {
                Abbreviation: "v$/day",
                Category: 29,
                Comparison: 3,
                KeyPath: "vPayPerDay",
                Name: "Pay Per Day",
                Type: "4",
                Variable: <Key1>{
                  RANGESTART: 10,
                  RANGEEND: 60,
                  VALUE: "26",
                },
              },
              {
                Abbreviation: "vCarryPay",
                Category: 29,
                Comparison: 1,
                KeyPath: "vCarryOutPay",
                Name: "Carry Out Fly Pay",
                Type: "5",
                Variable: <Key1>{
                  RANGESTART: 0,
                  RANGEEND: 30,
                  VALUE: "0",
                },
              },
              {
                Abbreviation: "vCOutVOPay",
                Category: 29,
                Comparison: 3,
                KeyPath: "vCarryOutVOPay",
                Name: "Carry Out VO Pay",
                Type: "10",
                Variable: <Key1>{
                  RANGESTART: 1,
                  RANGEEND: 30,
                  VALUE: "10",
                },
              },
              {
                Abbreviation: "vBlk",
                Category: 29,
                Comparison: 3,
                KeyPath: "vBlockTime",
                Name: "Block Time",
                Type: "6",
                Variable: <Key1>{
                  RANGESTART: 1,
                  RANGEEND: 90,
                  VALUE: "30",
                },
              },
              {
                Abbreviation: "vOff",
                Category: 29,
                Comparison: 3,
                KeyPath: "vDaysOff",
                Name: "Days Off",
                Type: "7",
                Variable: <Key1>{
                  RANGESTART: 10,
                  RANGEEND: 31,
                  VALUE: "20",
                },
              },
              {
                Abbreviation: "vVacayLength",
                Category: 29,
                Comparison: 3,
                KeyPath: "vEffectiveVacayLength",
                Name: "Eff. Vac. Length",
                Type: "8",
                Variable: <Key1>{
                  RANGESTART: 7,
                  RANGEEND: 25,
                  VALUE: "10",
                },
              },
              {
                Abbreviation: "vLongest",
                Category: 29,
                Comparison: 3,
                KeyPath: "vLongestBlockofDaysOff",
                Name: "Longest Blk Off",
                Type: "13",
                Variable: <Key1>{
                  RANGESTART: 7,
                  RANGEEND: 25,
                  VALUE: "10",
                },
              },
              {
                Abbreviation: "vVOutPay",
                Category: 29,
                Comparison: 3,
                KeyPath: "vVacayCarryOutPay",
                Name: "Carry Out VA Pay",
                Type: "9",
                Variable: <Key1>{
                  RANGESTART: 0,
                  RANGEEND: 30,
                  VALUE: "10",
                },
              },
              {
                Abbreviation: "vFrontVO",
                Category: 29,
                Comparison: 3,
                KeyPath: "vFrontVoPay",
                Name: "Front VO Pay",
                Type: "11",
                Variable: <Key1>{
                  RANGESTART: 1,
                  RANGEEND: 20,
                  VALUE: "10",
                },
              },
              {
                Abbreviation: "vBackVO",
                Category: 29,
                Comparison: 3,
                KeyPath: "vBackVoPay",
                Name: "Back VO Pay",
                Type: "12",
                Variable: <Key1>{
                  RANGESTART: 1,
                  RANGEEND: 20,
                  VALUE: "10",
                },
              },
            ],
          },
          {
            title: "Ground Time",
            Listfilter: [
              {
                Abbreviation: "Ground Time Max",
                Category: 41,
                Comparison: 3,
                KeyPath: "gTmax",
                Name: "Ground Time Max",
                Type: "2",
                Variable: <Key1>{
                  RANGESTART: 60,
                  RANGEEND: 360,
                  VALUE: "90",
                  NUMPLACES: 1,
                  DECIMAL: true,
                  STEP: 15,
                },
              },
              {
                Abbreviation: "Ground Time Average",
                Category: 42,
                Comparison: 3,
                KeyPath: "gTavg",
                Name: "Ground Time Average",
                Type: "2",
                Variable: <Key1>{
                  RANGESTART: 60,
                  RANGEEND: 360,
                  VALUE: "90",
                  NUMPLACES: 1,
                  DECIMAL: true,
                  STEP: 15,
                },
              },
            ],
          },
        ],
        lstSorts: [
          {
            title: "Days Off",
            ListSort: [
              {
                Abbreviation: "Off",
                Category: 0,
                KeyPath: "daysOff",
                Name: "Days Off",
                Ascending: false,
                IsMutable: true,
              },
            ],
          },
          {
            title: "Aircraft Changes",
            ListSort: [
              {
                Abbreviation: "Chngs",
                Category: 0,
                KeyPath: "numAircraftChanges",
                Name: "Aircraft Changes",
                Ascending: true,
                IsMutable: true,
              },
            ],
          },
          {
            title: "Legs",
            ListSort: [
              {
                Abbreviation: "Legs",
                Category: 0,
                KeyPath: "numLegs",
                Name: "Legs",
                Ascending: true,
                IsMutable: true,
              },
            ],
          },
          {
            title: "LODO",
            ListSort: [
              {
                Abbreviation: "lodo",
                Category: 0,
                KeyPath: "isLODO",
                Name: "LODO",
                Ascending: true,
                IsMutable: true,
              },
            ],
          },
          {
            title: "Aircraft Types",
            ListSort: [
              {
                Abbreviation: "700s",
                Category: 0,
                KeyPath: "aircraftType700Count",
                Name: "Aircraft Type 700",
                Ascending: true,
                IsMutable: true,
              },
              {
                Abbreviation: "800s",
                Category: 0,
                KeyPath: "aircraftType800Count",
                Name: "Aircraft Type 800",
                Ascending: true,
                IsMutable: true,
              },
              {
                Abbreviation: "8Max",
                Category: 0,
                KeyPath: "aircraftType8MaxCount",
                Name: "Aircraft Type 8Max",
                Ascending: true,
                IsMutable: true,
              },
              {
                Abbreviation: "7Max",
                Category: 0,
                KeyPath: "aircraftType7MaxCount",
                Name: "Aircraft Type 7Max",
                Ascending: true,
                IsMutable: true,
              },
            ],
          },
          {
            title: "AM/PM",
            ListSort: [
              {
                Abbreviation: "AM",
                Category: 0,
                KeyPath: "amPM",
                Name: "AM then PM",
                Ascending: true,
                IsMutable: false,
              },
              {
                Abbreviation: "PM",
                Category: 0,
                KeyPath: "amPM",
                Name: "PM then AM",
                Ascending: false,
                IsMutable: false,
              },
            ],
          },
          {
            title: "Block of Days Off",
            ListSort: [
              {
                Abbreviation: "BlkOff",
                Category: 0,
                KeyPath: "blockOfDaysOff",
                Name: "Block of Days Off",
                Ascending: false,
                IsMutable: true,
              },
            ],
          },
          {
            title: "Block Hours",
            ListSort: [
              {
                Abbreviation: "BlkHrs",
                Category: 0,
                KeyPath: "blockMinutes",
                Name: "Block Time",
                Ascending: true,
                IsMutable: true,
              },
            ],
          },
          {
            title: "Days of Reserve",
            ListSort: [
              {
                Abbreviation: "reserveDays",
                Category: 0,
                KeyPath: "reserveDays",
                Name: "Days of Reserve",
                Ascending: false,
                IsMutable: true,
              },
            ],
          },
          {
            title: "Days of Week",
            ListSort: [
              {
                Abbreviation: "Wknds",
                Category: 0,
                KeyPath: "weekendsCount",
                Name: "Weekends",
                Ascending: true,
                IsMutable: true,
              },
              {
                Abbreviation: "Su",
                Category: 0,
                KeyPath: "sundaysCount",
                Name: "Sundays",
                Ascending: true,
                IsMutable: true,
              },
              {
                Abbreviation: "Mo",
                Category: 0,
                KeyPath: "mondaysCount",
                Name: "Mondays",
                Ascending: true,
                IsMutable: true,
              },
              {
                Abbreviation: "Tu",
                Category: 0,
                KeyPath: "tuesdaysCount",
                Name: "Tuesdays",
                Ascending: true,
                IsMutable: true,
              },
              {
                Abbreviation: "Wed",
                Category: 0,
                KeyPath: "wednesdaysCount",
                Name: "Wednesdays",
                Ascending: true,
                IsMutable: true,
              },
              {
                Abbreviation: "Th",
                Category: 0,
                KeyPath: "thursdaysCount",
                Name: "Thursdays",
                Ascending: true,
                IsMutable: true,
              },
              {
                Abbreviation: "Fr",
                Category: 0,
                KeyPath: "fridaysCount",
                Name: "Fridays",
                Ascending: true,
                IsMutable: true,
              },
              {
                Abbreviation: "Sa",
                Category: 0,
                KeyPath: "saturdaysCount",
                Name: "Saturdays",
                Ascending: true,
                IsMutable: true,
              },
            ],
          },
          {
            title: "Trip Length",
            ListSort: [
              {
                Abbreviation: "Turns",
                Category: 0,
                KeyPath: "turnsCount",
                Name: "Turns",
                Ascending: true,
                IsMutable: true,
              },
              {
                Abbreviation: "2Days",
                Category: 0,
                KeyPath: "twoDayTripsCount",
                Name: "Two Day Trips",
                Ascending: true,
                IsMutable: true,
              },
              {
                Abbreviation: "3Days",
                Category: 0,
                KeyPath: "threeDayTripsCount",
                Name: "Three Day Trips",
                Ascending: true,
                IsMutable: true,
              },
              {
                Abbreviation: "4Days",
                Category: 0,
                KeyPath: "fourDayTripsCount",
                Name: "Four Day Trips",
                Ascending: true,
                IsMutable: true,
              },
            ],
          },
          {
            title: "Trips",
            ListSort: [
              {
                Abbreviation: "Trips",
                Category: 0,
                KeyPath: "numTrips",
                Name: "Trips",
                Ascending: true,
                IsMutable: true,
              },
            ],
          },
          {
            title: "Work Days",
            ListSort: [
              {
                Abbreviation: "Work",
                Category: 0,
                KeyPath: "workDays",
                Name: "Work Days",
                Ascending: true,
                IsMutable: true,
              },
            ],
          },
          {
            title: "WorkBlocks Count",
            ListSort: [
              {
                Abbreviation: "wrkBlkCount",
                Category: 0,
                KeyPath: "workBlockCount",
                Name: "WorkBlocks Count",
                Ascending: true,
                IsMutable: true,
              },
            ],
          },
          {
            title: "Earliest Departure",
            ListSort: [
              {
                Abbreviation: "EDep",
                Category: 0,
                KeyPath: "earliestDepartureTime",
                Name: "Earliest Departure",
                Ascending: false,
                IsMutable: true,
              },
            ],
          },
          {
            title: "Latest Arrival",
            ListSort: [
              {
                Abbreviation: "LArr",
                Category: 0,
                KeyPath: "latestArrivalTime",
                Name: "Latest Arrival",
                Ascending: true,
                IsMutable: true,
              },
            ],
          },
          {
            title: "Max Legs in a Day",
            ListSort: [
              {
                Abbreviation: "MLegs",
                Category: 0,
                KeyPath: "maxLegsInADay",
                Name: "Max Legs in a Day",
                Ascending: true,
                IsMutable: true,
              },
            ],
          },
          {
            title: "TAFB",
            ListSort: [
              {
                Abbreviation: "TAFB",
                Category: 0,
                KeyPath: "tafbMinutes",
                Name: "TAFB",
                Ascending: true,
                IsMutable: true,
              },
            ],
          },
          {
            title: "Flags",
            ListSort: [
              {
                Abbreviation: "flag",
                Category: 10,
                KeyPath: "flagOrder",
                Name: "Flags",
                Ascending: true,
                IsMutable: true,
              },
            ],
          },
          {
            title: "Cities",
            ListSort: [
              {
                Abbreviation: "OvernightCity",
                Category: 1,
                KeyPath: "",
                Type: 0,
                Name: "Overnight City",
                Ascending: false,
                IsMutable: true,
              },
              {
                Abbreviation: "Legs Thru",
                Category: 1,
                KeyPath: "",
                Type: 1,
                Name: "Legs Thru",
                Ascending: true,
                IsMutable: true,
              },
              {
                Abbreviation: "NonConLegs",
                Category: 1,
                KeyPath: "",
                Type: 7,
                Name: "NonConUS Legs",
                Ascending: true,
                IsMutable: true,
              },
            ],
          },
          {
            title: "Regional Overnight Cities",
            ListSort: [
              {
                Abbreviation: "EC",
                Category: 1,
                KeyPath: "",
                Type: 2,
                Name: "East Coast",
                Ascending: false,
                IsMutable: true,
              },
              {
                Abbreviation: "WC",
                Category: 1,
                KeyPath: "",
                Type: 3,
                Name: "West Coast",
                Ascending: false,
                IsMutable: true,
              },
              {
                Abbreviation: "NonConUS",
                Category: 1,
                KeyPath: "",
                Type: 5,
                Name: "NonConUS",
                Ascending: false,
                IsMutable: true,
              },
              {
                Abbreviation: "AllC",
                Category: 1,
                KeyPath: "",
                Type: 6,
                Name: "All Cities",
                Ascending: false,
                IsMutable: true,
              },
              {
                Abbreviation: "Hawaii",
                Category: 1,
                KeyPath: "",
                Type: 8,
                Name: "Hawaii",
                Ascending: false,
                IsMutable: true,
              },
            ],
          },
          {
            title: "Days of the Month Off",
            ListSort: [
              {
                Abbreviation: "OffSort",
                Category: 8,
                KeyPath: "",
                Type: 0,
                Name: "Days I Want Off",
                Ascending: false,
                IsMutable: true,
                ArrayVariables: [],
              },
              {
                Abbreviation: "WorkSort",
                Category: 11,
                KeyPath: "",
                Type: 0,
                Name: "Days I Want To Work",
                Ascending: false,
                IsMutable: true,
                ArrayVariables: [],
              },
              {
                Abbreviation: "TripStartSort",
                Category: 12,
                KeyPath: "",
                Type: 0,
                Name: "Days I Don't Want Trips To Start",
                Ascending: true,
                IsMutable: true,
                ArrayVariables: [],
              },
            ],
          },
          {
            title: "Duty Time",
            ListSort: [
              {
                Abbreviation: "Dty",
                Category: 0,
                KeyPath: "dutyMinutes",
                Name: "Duty Hours",
                Ascending: true,
                IsMutable: true,
              },
              {
                Abbreviation: "Dty/Day",
                Category: 0,
                KeyPath: "dutyHoursPerDay",
                Name: "Duty Hours Per Day",
                Ascending: true,
                IsMutable: true,
              },
            ],
          },
          {
            title: "Pay",
            ListSort: [
              {
                Abbreviation: "Pay",
                Category: 0,
                KeyPath: "pay",
                Name: "Pay",
                Ascending: false,
                IsMutable: true,
              },
              {
                Abbreviation: "$/Blk",
                Category: 0,
                KeyPath: "payPerBlockHour",
                Name: "Pay per Block Hour",
                Ascending: false,
                IsMutable: true,
              },
              {
                Abbreviation: "$/Day",
                Category: 0,
                KeyPath: "payPerDay",
                Name: "Pay per Day",
                Ascending: false,
                IsMutable: true,
              },
              {
                Abbreviation: "$/Duty",
                Category: 0,
                KeyPath: "payPerDutyTime",
                Name: "Pay per Duty Hour",
                Ascending: false,
                IsMutable: true,
              },
              {
                Abbreviation: "$/Leg",
                Category: 0,
                KeyPath: "payPerLeg",
                Name: "Pay per Leg",
                Ascending: false,
                IsMutable: true,
              },
              {
                Abbreviation: "$/TAFB",
                Category: 0,
                KeyPath: "payPerTAFB",
                Name: "Pay per TAFB",
                Ascending: false,
                IsMutable: true,
              },
              {
                Abbreviation: "CoPay",
                Category: 0,
                KeyPath: "carryOutPay",
                Name: "Carry Out Pay",
                Ascending: false,
                IsMutable: true,
              },
              {
                Abbreviation: "linerig",
                Category: 0,
                KeyPath: "lineRig",
                Name: "Line Rig",
                Ascending: false,
                IsMutable: true,
              },
              {
                Abbreviation: "rigADG",
                Category: 0,
                KeyPath: "rigADG",
                Name: "rigADG",
                Ascending: false,
                IsMutable: true,
              },
              {
                Abbreviation: "rigDHR",
                Category: 0,
                KeyPath: "rigDHR",
                Name: "rigDHR",
                Ascending: false,
                IsMutable: true,
              },
              {
                Abbreviation: "rigDPM",
                Category: 0,
                KeyPath: "rigDPM",
                Name: "rigDPM",
                Ascending: false,
                IsMutable: true,
              },
              {
                Abbreviation: "rigTHR",
                Category: 0,
                KeyPath: "rigTHR",
                Name: "rigTHR",
                Ascending: false,
                IsMutable: true,
              },
              {
                Abbreviation: "TripTfp",
                Category: 0,
                KeyPath: "tripTfp",
                Name: "TripTfp",
                Ascending: false,
                IsMutable: true,
              },
              {
                Abbreviation: "Pay+CO",
                Category: 0,
                KeyPath: "payPlusCo",
                Name: "Pay+CO",
                Ascending: false,
                IsMutable: true,
              },
              {
                Abbreviation: "HoliRig",
                Category: 0,
                KeyPath: "holidayPay",
                Name: "HoliRig",
                Ascending: false,
                IsMutable: true,
              },
            ],
          },
          {
            title: "Overnights in Base",
            ListSort: [
              {
                Abbreviation: "OIBs",
                Category: 0,
                KeyPath: "overnightsInBase",
                Name: "Overnights in Base",
                Ascending: true,
                IsMutable: true,
              },
            ],
          },
          {
            title: "Passes through Base",
            ListSort: [
              {
                Abbreviation: "PTBs",
                Category: 6,
                KeyPath: "passesThruBase",
                Name: "Passes Through Base",
                Ascending: true,
                IsMutable: true,
                Type: 1,
              },
              {
                Abbreviation: "MidPTBs",
                Category: 6,
                KeyPath: "midTripPTBs",
                Name: "Mid-Trip PTBs",
                Ascending: true,
                IsMutable: true,
                Type: 0,
              },
            ],
          },
          {
            title: "Overnight Average",
            ListSort: [
              {
                Abbreviation: "OvAvg",
                Category: 0,
                KeyPath: "ovAvg",
                Name: "Overnight Average",
                Ascending: true,
                IsMutable: true,
                Type: 0,
              },
            ],
          },
          {
            title: "Overnight Length",
            ListSort: [
              {
                Abbreviation: "minNite",
                Category: 0,
                KeyPath: "minimumOvernightHours",
                Name: "Min O-Nite Length",
                Ascending: false,
                IsMutable: true,
              },
              {
                Abbreviation: "maxNite",
                Category: 0,
                KeyPath: "maximumOvernightHours",
                Name: "Max O-Nite Length",
                Ascending: false,
                IsMutable: true,
              },
            ],
          },
          {
            title: "ETOPS",
            ListSort: [
              {
                Abbreviation: "eTops",
                Category: 0,
                KeyPath: "isETOPS",
                Name: "ETOPS",
                Ascending: false,
                IsMutable: true,
              },
            ],
          },
          {
            title: "ETOPS Trips",
            ListSort: [
              {
                Abbreviation: "eTrips",
                Category: 0,
                KeyPath: "etopsTripsCount",
                Name: "ETOPS Trips",
                Ascending: false,
                IsMutable: true,
              },
            ],
          },
          {
            title: "Overlap Days",
            ListSort: [
              {
                Abbreviation: "OLap",
                Category: 0,
                KeyPath: "overlapDaysCount",
                Name: "Overlap Days",
                Ascending: true,
                IsMutable: true,
              },
            ],
          },
          {
            title: "Vac+LG",
            ListSort: [
              {
                Abbreviation: "TpL",
                Category: 0,
                KeyPath: "vTpLPay",
                Name: "Vac+LG",
                Ascending: true,
                IsMutable: true,
              },
            ],
          },
          {
            title: "Deadheads",
            ListSort: [
              {
                Abbreviation: "DHs",
                Category: 2,
                KeyPath: "deadheadsCount",
                Name: "Deadheads",
                Ascending: true,
                IsMutable: true,
                Type: 0,
              },
              {
                Abbreviation: "DH Start",
                Category: 2,
                KeyPath: "deadheadsAtStartCount",
                Name: "DH At Start",
                Ascending: true,
                IsMutable: true,
                Type: 1,
              },
              {
                Abbreviation: "DH End",
                Category: 2,
                KeyPath: "deadheadsAtEndCount",
                Name: "DH At End",
                Ascending: true,
                IsMutable: true,
                Type: 2,
              },
              {
                Abbreviation: "DH At Both",
                Category: 2,
                KeyPath: "deadheadsAtEitherCount",
                Name: "DH At Either",
                Ascending: true,
                IsMutable: true,
                Type: 3,
              },
            ],
          },
          {
            title: "Vacation",
            ListSort: [
              {
                Abbreviation: "vTotalPay",
                Category: 7,
                KeyPath: "vTotalPay",
                Name: "Total Pay",
                Ascending: false,
                IsMutable: true,
                Type: 0,
              },
              {
                Abbreviation: "vFlyPay",
                Category: 7,
                KeyPath: "vFlyPay",
                Name: "Fly Pay",
                Ascending: false,
                IsMutable: true,
                Type: 1,
              },
              {
                Abbreviation: "vVacationPay",
                Category: 7,
                KeyPath: "vVacationPay",
                Name: "Vac Pay in BP",
                Ascending: false,
                IsMutable: true,
                Type: 2,
              },
              {
                Abbreviation: "vVacPayNext",
                Category: 5,
                KeyPath: "vVacayPayNextBP",
                Name: "Vac Pay next BP",
                Ascending: false,
                IsMutable: true,
                Type: 15,
              },
              {
                Abbreviation: "vVacPayBoth",
                Category: 5,
                KeyPath: "vVacayPayBothBP",
                Name: "Vac Pay both BP",
                Ascending: false,
                IsMutable: true,
                Type: 14,
              },
              {
                Abbreviation: "v$/blk",
                Category: 7,
                KeyPath: "vPayPerBlock",
                Name: "Pay Per Block",
                Ascending: false,
                IsMutable: true,
                Type: 3,
              },
              {
                Abbreviation: "v$/day",
                Category: 7,
                KeyPath: "vPayPerDay",
                Name: "Pay Per Day",
                Ascending: false,
                IsMutable: true,
                Type: 4,
              },
              {
                Abbreviation: "vBlk",
                Category: 7,
                KeyPath: "vBlockTime",
                Name: "Block Time",
                Ascending: true,
                IsMutable: true,
                Type: 6,
              },
              {
                Abbreviation: "vOff",
                Category: 7,
                KeyPath: "vDaysOff",
                Name: "Days Off",
                Ascending: false,
                IsMutable: true,
                Type: 7,
              },
              {
                Abbreviation: "vVacayLength",
                Category: 5,
                KeyPath: "vEffectiveVacayLength",
                Name: "Eff. Vac. Length",
                Ascending: false,
                IsMutable: true,
                Type: 8,
              },
              {
                Abbreviation: "vVOutPay",
                Category: 7,
                KeyPath: "vVacayCarryOutPay",
                Name: "CarryOut VA Pay",
                Ascending: false,
                IsMutable: true,
                Type: 11,
              },
              {
                Abbreviation: "vaNE",
                Category: 5,
                KeyPath: "vAne",
                Name: "vaNE",
                Ascending: false,
                IsMutable: true,
                Type: 16,
              },
              {
                Abbreviation: "vpCuPlusVaNe",
                Category: 5,
                KeyPath: "vpCuPlusVaNe",
                Name: "vpCu+vaNe",
                Ascending: false,
                IsMutable: true,
                Type: 17,
              }
            ],
          },
          {
            title: "Commuting",
            ListSort: [
              {
                Abbreviation: "Commute",
                Category: 4,
                KeyPath: "commutabilityOverall",
                Name: "Commuting-Manual",
                Ascending: false,
                IsMutable: true,
                Variable: <CommutingManual>{
                  MON_THURS_DEPART: "0",
                  MON_THURS_RETURN: "0",
                  FRI_DEPART: "0",
                  FRI_RETURN: "0",
                  SAT_DEPART: "0",
                  SAT_RETURN: "0",
                  SUN_DEPART: "0",
                  SUN_RETURN: "0",
                  NoMidCheckState: true,
                },
              },
              {
                Abbreviation: "CmAuto",
                Category: 9,
                KeyPath: "commutabilityOverall",
                Name: "Commuting-Auto",
                Ascending: true,
                IsMutable: true,
                Variable: <CommutingAuto>{
                  commuteCity: null,
                  selectedConnectTime: null,
                  selectedTakeOffPadTimeValues: null,
                  selectedBackToBasePadTimeValues: null,
                  nonStop: null,
                  cmtFrBaOv: null,
                },
              },
            ],
          },
          {
            title: "Position",
            ListSort: [
              {
                Abbreviation: "positionABC",
                Category: 3,
                Type: 4,
                KeyPath: "",
                Name: "Quick Add Positions A-B-C",
                Ascending: false,
                IsMutable: false,
              },
              {
                Abbreviation: "A",
                Category: 3,
                Type: 0,
                KeyPath: "",
                Name: "Position A",
                Ascending: true,
                IsMutable: false,
              },
              {
                Abbreviation: "B",
                Category: 3,
                Type: 1,
                KeyPath: "",
                Name: "Position B",
                Ascending: true,
                IsMutable: false,
              },
              {
                Abbreviation: "C",
                Category: 3,
                Type: 2,
                KeyPath: "",
                Name: "Position C",
                Ascending: true,
                IsMutable: false,
              },
            ],
          },
          {
            title: "SWAPtimizer",
            ListSort: [
              {
                Abbreviation: "vTotalPay",
                Category: 5,
                KeyPath: "vTotalPay",
                Name: "Total Pay",
                Ascending: false,
                IsMutable: true,
                Type: 0,
              },
              {
                Abbreviation: "vFlyPay",
                Category: 5,
                KeyPath: "vFlyPay",
                Name: "Fly Pay",
                Ascending: false,
                IsMutable: true,
                Type: 1,
              },
              {
                Abbreviation: "vVacationPay",
                Category: 5,
                KeyPath: "vVacationPay",
                Name: "Vac Pay in BP",
                Ascending: false,
                IsMutable: true,
                Type: 2,
              },
              {
                Abbreviation: "vVacPayNext",
                Category: 5,
                KeyPath: "vVacayPayNextBP",
                Name: "Vac Pay next BP",
                Ascending: false,
                IsMutable: true,
                Type: 15,
              },
              {
                Abbreviation: "vVacPayBoth",
                Category: 5,
                KeyPath: "vVacayPayBothBP",
                Name: "Vac Pay both BP",
                Ascending: false,
                IsMutable: true,
                Type: 14,
              },
              {
                Abbreviation: "v$/blk",
                Category: 5,
                KeyPath: "vPayPerBlock",
                Name: "Pay Per Block",
                Ascending: false,
                IsMutable: true,
                Type: 3,
              },
              {
                Abbreviation: "v$/day",
                Category: 5,
                KeyPath: "vPayPerDay",
                Name: "Pay Per Day",
                Ascending: false,
                IsMutable: true,
                Type: 4,
              },
              {
                Abbreviation: "vBlk",
                Category: 5,
                KeyPath: "vBlockTime",
                Name: "Block Time",
                Ascending: false,
                IsMutable: true,
                Type: 6,
              },
              {
                Abbreviation: "vCOutPay",
                Category: 5,
                KeyPath: "vCarryOutPay",
                Name: "CarryOut Fly Pay",
                Ascending: false,
                IsMutable: true,
                Type: 5,
              },
              {
                Abbreviation: "vCOutVOPay",
                Category: 5,
                KeyPath: "vCarryOutVOPay",
                Name: "CarryOut VO Pay",
                Ascending: false,
                IsMutable: true,
                Type: 12,
              },
              {
                Abbreviation: "vOff",
                Category: 5,
                KeyPath: "vDaysOff",
                Name: "Days Off",
                Ascending: false,
                IsMutable: true,
                Type: 7,
              },
              {
                Abbreviation: "vVacayLength",
                Category: 5,
                KeyPath: "vEffectiveVacayLength",
                Name: "Eff. Vac. Length",
                Ascending: false,
                IsMutable: true,
                Type: 8,
              },
              {
                Abbreviation: "vLongest",
                Category: 5,
                KeyPath: "vLongestBlockofDaysOff",
                Name: "Longest Blk Off",
                Ascending: false,
                IsMutable: true,
                Type: 13,
              },
              {
                Abbreviation: "vVOutPay",
                Category: 5,
                KeyPath: "vVacayCarryOutPay",
                Name: "CarryOut VA Pay",
                Ascending: false,
                IsMutable: true,
                Type: 11,
              },
              {
                Abbreviation: "vFrontVO",
                Category: 5,
                KeyPath: "vFrontVoPay",
                Name: "Front VO Pay",
                Ascending: false,
                IsMutable: true,
                Type: 9,
              },
              {
                Abbreviation: "vBackVO",
                Category: 5,
                KeyPath: "vBackVoPay",
                Name: "Back VO Pay",
                Ascending: false,
                IsMutable: true,
                Type: 10,
              },
              {
                Abbreviation: "vaNE",
                Category: 5,
                KeyPath: "vAne",
                Name: "vaNE",
                Ascending: false,
                IsMutable: true,
                Type: 16,
              }
            ],
          },
          {
            title: "Ground Time",
            ListSort: [
              {
                Abbreviation: "Ground Time Max",
                Category: 0,
                KeyPath: "gTmax",
                Name: "Ground Time Max",
                Ascending: true,
                IsMutable: true,
                Type: 0,
                Order: 3,
              },
              {
                Abbreviation: "Ground Time Average",
                Category: 0,
                KeyPath: "gTavg",
                Name: "Ground Time Average",
                Ascending: true,
                IsMutable: true,
                Type: 0,
                Order: 3,
              },
            ],
          },
          {
            title: "RedEyeTrips",
            ListSort: [
              {
                Abbreviation: "RedEyeTrips",
                Category: 0,
                KeyPath: "redEyeTrips",
                Name: "RedEyeTrips",
                Ascending: true,
                IsMutable: true,
              },
            ],
          },
        ],
      },
    ];
    return returnVal[0];
  };

  /**
   * @method getSortPopUpData - Hard Coded Sort Pop-Up properties
   */
  public getSortPopUpData = (): SortPopUpData[] => {
    const sortData: SortPopUpData[] = [
      {
        Id: 75,
        VacationType: 2, //Vacation Wbidmax
        SortName: "Vacation",
        DisplayName: "WBidmax",
        Children: [
          {
            Id: 76,
            VacationType: 2,
            SortName: "vTotalPay",
            DisplayName: "Total Pay",
            SortType: "singleVac",
            Children: null,
          },
          {
            Id: 77,
            VacationType: 2,
            SortName: "vFlyPay",
            DisplayName: "Fly Pay",
            SortType: "singleVac",
            Children: null,
          },
          {
            Id: 78,
            VacationType: 2,
            SortName: "vVacationPay",
            DisplayName: "Vac Pay in BP",
            SortType: "singleVac",
            Children: null,
          },
          {
            Id: 79,
            VacationType: 2,
            SortName: "vVOutPay",
            DisplayName: "CarryOut VA Pay",
            SortType: "singleVac",
            isVacFAOnly: true,
            Children: null,
          },
          {
            Id: 80,
            VacationType: 2,
            SortName: "vVacPayNext",
            DisplayName: "Vac Pay next BP",
            SortType: "singleVac",
            Children: null,
          },
          {
            Id: 81,
            VacationType: 2,
            SortName: "vVacPayBoth",
            DisplayName: "Vac Pay Both BP",
            SortType: "singleVac",
            Children: null,
          },
          {
            Id: 82,
            VacationType: 2,
            SortName: "v$/blk",
            DisplayName: "Pay per Block",
            SortType: "singleVac",
            Children: null,
          },
          {
            Id: 83,
            VacationType: 2,
            SortName: "v$/day",
            DisplayName: "Pay per Day",
            SortType: "singleVac",
            Children: null,
          },
          {
            Id: 84,
            VacationType: 2,
            SortName: "vBlk",
            DisplayName: "Block Time",
            SortType: "singleVac",
            Children: null,
          },
          {
            Id: 85,
            VacationType: 2,
            SortName: "vOff",
            DisplayName: "Days Off",
            SortType: "singleVac",
            Children: null,
          },
          {
            Id: 86,
            VacationType: 2,
            SortName: "vVacayLength",
            DisplayName: "Eff. Vac. Length",
            SortType: "singleVac",
            Children: null,
          },
          {
            Id: 87,
            VacationType: 2,
            SortName: "vaNE",
            DisplayName: "vaNE",
            SortType: "singleVac",
            Children: null,
          },
          {
            Id: 88,
            VacationType: 2,
            SortName: "vpCuPlusVaNe",
            DisplayName: "vpCu+vaNe",
            SortType: "singleVac",
            Children: null,
          },
        ],
      },
      {
        Id: 86,
        VacationType: 3, //Vacation Swaptimizer
        SortName: "SWAPtimizer",
        DisplayName: "SWAPtimizer",
        Children: [
          {
            Id: 87,
            VacationType: 3,
            SortName: "vTotalPay",
            DisplayName: "Total Pay",
            SortType: "singleVac",
            Children: null,
          },
          {
            Id: 88,
            VacationType: 3,
            SortName: "vFlyPay",
            DisplayName: "Fly Pay",
            SortType: "singleVac",
            Children: null,
          },
          {
            Id: 89,
            VacationType: 3,
            SortName: "vVacationPay",
            DisplayName: "Vac Pay in BP",
            SortType: "singleVac",
            Children: null,
          },
          {
            Id: 90,
            VacationType: 3,
            SortName: "v$/blk",
            DisplayName: "Pay per Block",
            SortType: "singleVac",
            Children: null,
          },
          {
            Id: 91,
            VacationType: 3,
            SortName: "v$/day",
            DisplayName: "Pay per Day",
            SortType: "singleVac",
            Children: null,
          },
          {
            Id: 92,
            VacationType: 3,
            SortName: "vBlk",
            DisplayName: "Block Time",
            SortType: "singleVac",
            Children: null,
          },
          // {
          //   Id: 93,
          //   VacationType: 3,
          //   SortName: "vCOutPay",
          //   DisplayName: "CarryOut Fly Pay",
          //   SortType: "singleVac",
          //   Children: null,
          // },
          {
            Id: 93,
            VacationType: 3,
            SortName: "vOff",
            DisplayName: "Days Off",
            SortType: "singleVac",
            Children: null,
          },
          {
            Id: 94,
            VacationType: 3,
            SortName: "vVacayLength",
            DisplayName: "Eff. Vac. Length",
            SortType: "singleVac",
            Children: null,
          },
          {
            Id: 95,
            VacationType: 3,
            SortName: "vLongest",
            DisplayName: "Longest Blk Off",
            SortType: "singleVac",
            Children: null,
          },
          {
            Id: 96,
            VacationType: 3,
            SortName: "vVOutPay",
            DisplayName: "Carry Out Fly Pay",
            SortType: "singleVac",
            isVacFAOnly: true,
            Children: null,
          },
          {
            Id: 97,
            VacationType: 3,
            SortName: "vFrontVO",
            DisplayName: "Front VO Pay",
            SortType: "singleVac",
            Children: null,
          },
          {
            Id: 98,
            VacationType: 3,
            SortName: "vBackVO",
            DisplayName: "Back VO Pay",
            SortType: "singleVac",
            Children: null,
          },
          {
            Id: 99,
            VacationType: 3,
            SortName: "vaNE",
            DisplayName: "vaNE",
            SortType: "singleVac",
            Children: null,
          },
        ],
      },
      {
        Id: 1,
        VacationType: 1,
        SortName: "Chngs",
        DisplayName: "Aircraft Changes",
        SortType: "single",
        Children: null,
      },
      {
        Id: 2,
        VacationType: 1,
        SortName: "Aircraft Types",
        DisplayName: "Aircraft Types",
        Children: [
          {
            Id: 3,
            VacationType: 1,
            SortName: "700s",
            DisplayName: "Aircraft Type 700",
            SortType: "single",
            Children: null,
          },
          {
            Id: 4,
            VacationType: 1,
            SortName: "800s",
            DisplayName: "Aircraft Type 800",
            SortType: "single",
            Children: null,
          },
          {
            Id: 5,
            VacationType: 1,
            SortName: "8Max",
            DisplayName: "Aircraft Type 8Max",
            SortType: "single",
            Children: null,
          },
          {
            Id: 6,
            VacationType: 1,
            SortName: "7Max",
            DisplayName: "Aircraft Type 7Max",
            SortType: "single",
            Children: null,
          },
        ],
      },
      {
        Id: 6,
        VacationType: 1,
        SortName: "AM/PM",
        DisplayName: "AM/PM",
        Children: [
          {
            Id: 7,
            VacationType: 1,
            SortName: "AM",
            DisplayName: "AM then PM",
            SortType: "empty",
            Children: null,
          },
          {
            Id: 8,
            VacationType: 1,
            SortName: "PM",
            DisplayName: "PM then AM",
            SortType: "empty",
            Children: null,
          },
        ],
      },
      {
        Id: 9,
        VacationType: 1,
        SortName: "BlkOff",
        DisplayName: "Block of Days Off",
        SortType: "single",
        Children: null,
      },
      {
        Id: 10,
        VacationType: 1,
        SortName: "BlkHrs",
        DisplayName: "Block Time",
        SortType: "single",
        Children: null,
      },
      {
        Id: 11,
        VacationType: 1,
        SortName: "Cities",
        DisplayName: "Cities",
        Children: [
          {
            Id: 12,
            VacationType: 1,
            SortName: "OvernightCity",
            DisplayName: "Overnight City",
            SortType: "double",
            Children: null,
          },
          {
            Id: 13,
            VacationType: 1,
            SortName: "Legs Thru",
            DisplayName: "Legs Thru",
            SortType: "double",
            Children: null,
          },
          {
            Id: 14,
            VacationType: 1,
            SortName: "NonConLegs",
            DisplayName: "NonConUS Legs",
            SortType: "single",
            Children: null,
          },
          {
            Id: 15,
            VacationType: 1,
            SortName: "Regional Overnight Cities",
            DisplayName: "Regional Overnight Cities",
            Children: [
              {
                Id: 16,
                VacationType: 1,
                SortName: "EC",
                DisplayName: "East Coast",
                SortType: "multiCity",
                Children: null,
              },
              {
                Id: 17,
                VacationType: 1,
                SortName: "WC",
                DisplayName: "West Coast",
                SortType: "multiCity",
                Children: null,
              },
              {
                Id: 18,
                VacationType: 1,
                SortName: "NonConUS",
                DisplayName: "NonConUS",
                SortType: "multiCity",
                Children: null,
              },
              {
                Id: 19,
                VacationType: 1,
                SortName: "AllC",
                DisplayName: "All Cities",
                SortType: "multiCity",
                Children: null,
              },
              {
                Id: 20,
                VacationType: 1,
                SortName: "Hawaii",
                DisplayName: "Hawaii",
                SortType: "multiCity",
                Children: null,
              },
            ],
          },
        ],
      },
      {
        Id: 21,
        VacationType: 1,
        SortName: "Commuting",
        DisplayName: "Commuting",
        Children: [
          {
            Id: 22,
            VacationType: 1,
            SortName: "Commute",
            DisplayName: "Commuting - Manual",
            SortType: "manual",
            Children: null,
          },
          {
            Id: 23,
            VacationType: 1,
            SortName: "CmAuto",
            DisplayName: "Commuting - Auto",
            SortType: "commute-auto",
            Children: null,
          },
        ],
      },
      {
        Id: 24,
        VacationType: 1,
        SortName: "Days of Week",
        DisplayName: "Days of Week",
        Children: [
          {
            Id: 25,
            VacationType: 1,
            SortName: "Wknds",
            DisplayName: "Weekends",
            SortType: "single",
            Children: null,
          },
          {
            Id: 26,
            VacationType: 1,
            SortName: "Su",
            DisplayName: "Sundays",
            SortType: "single",
            Children: null,
          },
          {
            Id: 27,
            VacationType: 1,
            SortName: "Mo",
            DisplayName: "Mondays",
            SortType: "single",
            Children: null,
          },
          {
            Id: 28,
            VacationType: 1,
            SortName: "Tu",
            DisplayName: "Tuesdays",
            SortType: "single",
            Children: null,
          },
          {
            Id: 29,
            VacationType: 1,
            SortName: "Wed",
            DisplayName: "Wednesdays",
            SortType: "single",
            Children: null,
          },
          {
            Id: 30,
            VacationType: 1,
            SortName: "Th",
            DisplayName: "Thursdays",
            SortType: "single",
            Children: null,
          },
          {
            Id: 31,
            VacationType: 1,
            SortName: "Fr",
            DisplayName: "Fridays",
            SortType: "single",
            Children: null,
          },
          {
            Id: 32,
            VacationType: 1,
            SortName: "Sa",
            DisplayName: "Saturdays",
            SortType: "single",
            Children: null,
          },
        ],
      },
      {
        Id: 33,
        VacationType: 1,
        SortName: "Off",
        DisplayName: "Days Off",
        SortType: "single",
        Children: null,
      },
      {
        Id: 105,
        VacationType: 1,
        SortName: "reserveDays",
        DisplayName: "Days of Reserve",
        SortType: "single",
        Children: null,
      },
      {
        Id: 34,
        VacationType: 1,
        SortName: "Days of the Month Off",
        DisplayName: "Days of the Month",
        // SortType: "daysOfMonth",
        Children: [
          {
            Id: 100,
            VacationType: 1,
            SortName: "OffSort",
            DisplayName: "Days I want off",
            SortType: "daysOfMonth",
            Children: null,
          },
          {
            Id: 101,
            VacationType: 1,
            SortName: "WorkSort",
            DisplayName: "Days I want to Work",
            SortType: "daysOfMonth",
            Children: null,
          },
          {
            Id: 102,
            VacationType: 1,
            SortName: "TripStartSort",
            DisplayName: "Days I Don't Want Trips to Start",
            SortType: "daysOfMonth",
            Children: null,
          },
        ],
      },
      {
        Id: 35,
        VacationType: 1,
        SortName: "Deadheads",
        DisplayName: "Deadheads",
        Children: [
          {
            Id: 36,
            VacationType: 1,
            SortName: "DHs",
            DisplayName: "Deadheads",
            SortType: "single",
            Children: null,
          },
          {
            Id: 37,
            VacationType: 1,
            SortName: "DH Start",
            DisplayName: "DH At Start",
            SortType: "city",
            Children: null,
          },
          {
            Id: 38,
            VacationType: 1,
            SortName: "DH End",
            DisplayName: "DH At End",
            SortType: "city",
            Children: null,
          },
          {
            Id: 39,
            VacationType: 1,
            SortName: "DH At Both",
            DisplayName: "DH At Either",
            SortType: "city",
            Children: null,
          },
        ],
      },
      {
        Id: 40,
        VacationType: 1,
        SortName: "Duty Time",
        DisplayName: "Duty Time",
        Children: [
          {
            Id: 41,
            VacationType: 1,
            SortName: "Dty",
            DisplayName: "Duty Hours",
            SortType: "single",
            Children: null,
          },
          {
            Id: 42,
            VacationType: 1,
            SortName: "Dty/Day",
            DisplayName: "Duty Hours Per Day",
            SortType: "single",
            Children: null,
          },
        ],
      },
      {
        Id: 43,
        VacationType: 1,
        SortName: "EDep",
        DisplayName: "Earliest Departure",
        SortType: "single",
        Children: null,
      },
      {
        Id: 44,
        VacationType: 1,
        SortName: "eTops",
        DisplayName: "ETOPS",
        SortType: "single",
        Children: null,
      },
      {
        Id: 99,
        VacationType: 1,
        SortName: "eTrips",
        DisplayName: "ETOPS Trips",
        SortType: "single",
        Children: null,
      },
      {
        Id: 98,
        VacationType: 1,
        SortName: "flag",
        DisplayName: "Flags",
        SortType: "flagType",
        Children: null,
      },
      {
        Id: 35,
        VacationType: 1,
        SortName: "Ground Time",
        DisplayName: "Ground Time",
        Children: [
          {
            Id: 104,
            VacationType: 1,
            SortName: "Ground Time Average",
            DisplayName: "Ground Time Average",
            SortType: "single",
            Children: null,
          },
          {
            Id: 103,
            VacationType: 1,
            SortName: "Ground Time Max",
            DisplayName: "Ground Time Max",
            SortType: "single",
            Children: null,
          },
        ],
      }, 
      {
        Id: 45,
        VacationType: 1,
        SortName: "LArr",
        DisplayName: "Latest Arrival",
        SortType: "single",
        Children: null,
      },
      {
        Id: 46,
        VacationType: 1,
        SortName: "Legs",
        DisplayName: "Legs",
        SortType: "single",
        Children: null,
      },
      {
        Id: 114,
        VacationType: 1,
        SortName: "lodo",
        DisplayName: "LODO",
        SortType: "single",
        Children: null,
      },
      {
        Id: 47,
        VacationType: 1,
        SortName: "MLegs",
        DisplayName: "Max Legs in a Day",
        SortType: "single",
        Children: null,
      },
      {
        Id: 48,
        VacationType: 1,
        SortName: "OLap",
        DisplayName: "Overlap Days",
        SortType: "single",
        Children: null,
      },
      {
        Id: 49,
        VacationType: 1,
        SortName: "OvAvg",
        DisplayName: "Overnight Average",
        SortType: "single",
        Children: null,
      },
      {
        Id: 50,
        VacationType: 1,
        SortName: "OIBs",
        DisplayName: "Overnights in Base",
        SortType: "single",
        Children: null,
      },
      {
        Id: 51,
        VacationType: 1,
        SortName: "Overnight Length",
        DisplayName: "Overnight Length",
        Children: [
          {
            Id: 52,
            VacationType: 1,
            SortName: "minNite",
            DisplayName: "Min O-Nite Length",
            SortType: "single",
            Children: null,
          },
          {
            Id: 53,
            VacationType: 1,
            SortName: "maxNite",
            DisplayName: "Max O-Nite Length",
            SortType: "single",
            Children: null,
          },
        ],
      },
      {
        Id: 54,
        VacationType: 1,
        SortName: "Passes through Base",
        DisplayName: "Passes Through Base",
        Children: [
          {
            Id: 55,
            VacationType: 1,
            SortName: "PTBs",
            DisplayName: "Passes Through Base",
            SortType: "single",
            Children: null,
          },
          {
            Id: 56,
            VacationType: 1,
            SortName: "MidPTBs",
            DisplayName: "Mid-Trip PTBs",
            SortType: "single",
            Children: null,
          },
        ],
      },
      {
        Id: 57,
        VacationType: 1,
        SortName: "Pay",
        DisplayName: "Pay",
        Children: [
          {
            Id: 58,
            VacationType: 1,
            SortName: "Pay",
            DisplayName: "Pay",
            SortType: "single",
            Children: null,
          },
          {
            Id: 59,
            VacationType: 1,
            SortName: "$/Blk",
            DisplayName: "Pay per Block Hour",
            SortType: "single",
            Children: null,
          },
          {
            Id: 60,
            VacationType: 1,
            SortName: "$/Day",
            DisplayName: "Pay per Day",
            SortType: "single",
            Children: null,
          },
          {
            Id: 61,
            VacationType: 1,
            SortName: "$/Duty",
            DisplayName: "Pay per Duty Hour",
            SortType: "single",
            Children: null,
          },
          {
            Id: 62,
            VacationType: 1,
            SortName: "$/Leg",
            DisplayName: "Pay per Leg",
            SortType: "single",
            Children: null,
          },
          {
            Id: 63,
            VacationType: 1,
            SortName: "$/TAFB",
            DisplayName: "Pay per TAFB",
            SortType: "single",
            Children: null,
          },
          {
            Id: 64,
            VacationType: 1,
            SortName: "CoPay",
            DisplayName: "Carry Out Pay",
            SortType: "single",
            Children: null,
          },
          {
            Id: 65,
            VacationType: 1,
            SortName: "linerig",
            DisplayName: "Line Rig",
            SortType: "single",
            Children: null,
          },
          {
            Id: 106,
            VacationType: 1,
            SortName: "rigADG",
            DisplayName: "rigADG",
            SortType: "single",
            Children: null,
          },
          {
            Id: 107,
            VacationType: 1,
            SortName: "rigDHR",
            DisplayName: "rigDHR",
            SortType: "single",
            Children: null,
          },
          {
            Id: 108,
            VacationType: 1,
            SortName: "rigDPM",
            DisplayName: "rigDPM",
            SortType: "single",
            Children: null,
          },
          {
            Id: 109,
            VacationType: 1,
            SortName: "rigTHR",
            DisplayName: "rigTHR",
            SortType: "single",
            Children: null,
          },
          {
            Id: 110,
            VacationType: 1,
            SortName: "TripTfp",
            DisplayName: "Trip Tfp",
            SortType: "single",
            Children: null,
          },
          {
            Id: 111,
            VacationType: 1,
            SortName: "Pay+CO",
            DisplayName: "Pay+CO",
            SortType: "single",
            Children: null,
          },
          {
            Id: 113,
            VacationType: 1,
            SortName: "HoliRig",
            DisplayName: "HoliRig",
            SortType: "single",
            Children: null,
          },
        ],
      },
      {
        Id: 87,
        VacationType: 1,
        SortName: "Position",
        DisplayName: "Position",
        FAOnly: true,
        Children: [
          {
            Id: 88,
            VacationType: 1,
            SortName: "positionABC",
            DisplayName: "Quick Add Positions A-B-C",
            SortType: "empty",
            Children: null,
            FAOnly: true,
          },
          {
            Id: 89,
            VacationType: 1,
            SortName: "A",
            DisplayName: "Position A",
            SortType: "empty",
            Children: null,
            FAOnly: true,
          },
          {
            Id: 90,
            VacationType: 1,
            SortName: "B",
            DisplayName: "Position B",
            SortType: "empty",
            Children: null,
            FAOnly: true,
          },
          {
            Id: 91,
            VacationType: 1,
            SortName: "C",
            DisplayName: "Position C",
            SortType: "empty",
            Children: null,
            FAOnly: true,
          },
        ],
      },
      {
        Id: 112,
        VacationType: 1,
        SortName: "RedEyeTrips",
        DisplayName: "Red Eye Trips",
        SortType: "single",
        Children: null,
      },
      {
        Id: 66,
        VacationType: 1,
        SortName: "TAFB",
        DisplayName: "TAFB",
        SortType: "single",
        Children: null,
      },
      {
        Id: 67,
        VacationType: 1,
        SortName: "Trip Length",
        DisplayName: "Trip Length",
        Children: [
          {
            Id: 68,
            VacationType: 1,
            SortName: "Turns",
            DisplayName: "Turns",
            SortType: "single",
            Children: null,
          },
          {
            Id: 69,
            VacationType: 1,
            SortName: "2Days",
            DisplayName: "Two Day Trips",
            SortType: "single",
            Children: null,
          },
          {
            Id: 70,
            VacationType: 1,
            SortName: "3Days",
            DisplayName: "Three Day Trips",
            SortType: "single",
            Children: null,
          },
          {
            Id: 71,
            VacationType: 1,
            SortName: "4Days",
            DisplayName: "Four Day Trips",
            SortType: "single",
            Children: null,
          },
        ],
      },
      {
        Id: 72,
        VacationType: 1,
        SortName: "Trips",
        DisplayName: "Trips",
        SortType: "single",
        Children: null,
      },
      {
        Id: 73,
        VacationType: 1,
        SortName: "TpL",
        DisplayName: "Vac+LG",
        SortType: "single",
        Children: null,
      },
      {
        Id: 74,
        VacationType: 1,
        SortName: "Work",
        DisplayName: "Work Days",
        SortType: "single",
        Children: null,
      },
      {
        Id: 100,
        VacationType: 1,
        SortName: "wrkBlkCount",
        DisplayName: "WorkBlocks Count",
        SortType: "single",
        Children: null,
      },
    ];
    return sortData;
  };
  /**
   * @method getQuickFilterUIData - Hard Coded Quick filter properties
   */
  public getQuickFilterUIData = (): QuickFilterUIList[] => {
    const quickFilterData: QuickFilterUIList[] = [
      {
        displayName: "ConUS",
        filterName: "ConUS",
        isApplied: false,
        region: "first",
        isHidden: true,
      },
      {
        displayName: "NonConUS",
        filterName: "NonConUS",
        isApplied: false,
        region: "first",
        isHidden: true,
      },
      {
        displayName: "Hard Lines",
        filterName: "Hard",
        isApplied: false,
        region: "first",
        isHidden: true,
      },
      {
        displayName: "mixRes",
        filterName: "Mixed",
        isApplied: false,
        region: "first",
        isHidden: true,
      },
      {
        displayName: "Reserve",
        filterName: "Reserve",
        isApplied: false,
        region: "first",
        isHidden: true,
      },
      {
        displayName: "Blank",
        filterName: "Blank",
        isApplied: false,
        region: "first",
        isHidden: true,
      },
      {
        displayName: "ETOPS",
        filterName: "ETOPS",
        isApplied: false,
        region: "first",
        isHidden: true,
      },
      {
        displayName: "ETOPS RES",
        filterName: "ETOPS RES",
        isApplied: false,
        region: "first",
        isHidden: true,
      },
      {
        displayName: "LODO",
        filterName: "LODO",
        isApplied: false,
        region: "first",
        isHidden: true,
      },
      {
        displayName: "AM Lines",
        filterName: "AM Lines",
        isApplied: false,
        region: "second",
        isHidden: true,
      },
      {
        displayName: "PM Lines",
        filterName: "PM Lines",
        isApplied: false,
        region: "second",
        isHidden: true,
      },
      {
        displayName: "Mixed AM/PM Lines",
        filterName: "Mixed Lines",
        isApplied: false,
        region: "second",
        isHidden: true,
      },
      {
        displayName: "Red Eyes",
        filterName: "RedEyes",
        isApplied: false,
        region: "second",
        isHidden: true,
      },
      {
        displayName: "Sun",
        filterName: "Sundays",
        isApplied: false,
        region: "third",
        isHidden: true,
      },
      {
        displayName: "Mon",
        filterName: "Mondays",
        isApplied: false,
        region: "third",
        isHidden: true,
      },
      {
        displayName: "Tue",
        filterName: "Tuesdays",
        isApplied: false,
        region: "third",
        isHidden: true,
      },
      {
        displayName: "Wed",
        filterName: "Wednesdays",
        isApplied: false,
        region: "third",
        isHidden: true,
      },
      {
        displayName: "Thu",
        filterName: "Thursdays",
        isApplied: false,
        region: "third",
        isHidden: true,
      },
      {
        displayName: "Fri",
        filterName: "Fridays",
        isApplied: false,
        region: "third",
        isHidden: true,
      },
      {
        displayName: "Sat",
        filterName: "Saturdays",
        isApplied: false,
        region: "third",
        isHidden: true,
      },
      {
        displayName: "Turns",
        filterName: "Turns",
        isApplied: false,
        region: "fourth",
        isHidden: true,
      },
      {
        displayName: "Two Days",
        filterName: "Two Day Trips",
        isApplied: false,
        region: "fourth",
        isHidden: true,
      },
      {
        displayName: "Three Days",
        filterName: "Three Day Trips",
        isApplied: false,
        region: "fourth",
        isHidden: true,
      },
      {
        displayName: "Four Days",
        filterName: "Four Day Trips",
        isApplied: false,
        region: "fourth",
        isHidden: true,
      },
      {
        displayName: "SnrAMres",
        filterName: "SnrAMres",
        isApplied: false,
        region: "fifth",
        isHidden: true,
      },
      {
        displayName: "SnrPMres",
        filterName: "SnrPMres",
        isApplied: false,
        region: "fifth",
        isHidden: true,
      },
      {
        displayName: "JnrAMres",
        filterName: "JnrAMres",
        isApplied: false,
        region: "fifth",
        isHidden: true,
      },
      {
        displayName: "JnrPMres",
        filterName: "JnrPMres",
        isApplied: false,
        region: "fifth",
        isHidden: true,
      },
      {
        displayName: "JnrLateRes",
        filterName: "JnrLateRes",
        isApplied: false,
        region: "fifth",
        isHidden: true,
      },
      {
        displayName: "Pos A",
        filterName: "Pos A",
        isApplied: false,
        region: "sixth",
        isHidden: true,
      },
      {
        displayName: "Pos B",
        filterName: "Pos B",
        isApplied: false,
        region: "sixth",
        isHidden: true,
      },
      {
        displayName: "Pos C",
        filterName: "Pos C",
        isApplied: false,
        region: "sixth",
        isHidden: true,
      },
      {
        displayName: "Pos D",
        filterName: "Pos D",
        isApplied: false,
        region: "sixth",
        isHidden: true,
      },
      {
        displayName: "Multi",
        filterName: "Multi",
        isApplied: false,
        region: "sixth",
        isHidden: true,
      },
    ];
    return quickFilterData;
  };
  /**
   * Get default state with quick filters
   */
  public getDefaultState = (): CrewbidState => {
    const returnVal: CrewbidState[] = [
      {
        lstQuickFilters: [
          {
            conUs: false,
            nonConUs: false,
            reserve: false,
            blank: false,
            etops: false,
            etopsRes: false,
            amLines: false,
            pmLines: false,
            mixedLines: false,
            sun: false,
            mon: false,
            tue: false,
            wed: false,
            thu: false,
            fri: false,
            sat: false,
            turns: false,
            twoDays: false,
            threeDays: false,
            fourDays: false,
            posA: false,
            posB: false,
            posC: false,
            posD: false,
            posMultiple: false,
            posNA: false,
            hard: false,
            mixed: false,
            noReserve: false,
            redEyeAmPmLines: false,
            SnrAMres: false, 
            SnrPMres: false, 
            JnrAMres: false, 
            JnrPMres: false, 
            JnrLateRes: false,
          },
        ],
      },
    ];
    return returnVal[0];
  };

  /**
   * @method getFlagColors1 To get colors of the flags
   */
  public getFlagColorsList = (): FlagColorList[] => {
    const flagColorArray: FlagColorList[] = [
      {
        order: 0,
        color: "None",
        hexValue: "none",
      },
      {
        order: 2,
        color: "Green",
        hexValue: "#009b22",
      },
      {
        order: 4,
        color: "Yellow",
        hexValue: "#ecba0b",
      },
      {
        order: 5,
        color: "Orange",
        hexValue: "#ff7600",
      },
      {
        order: 3,
        color: "Red",
        hexValue: "#e41010",
      },
      {
        order: 1,
        color: "Blue",
        hexValue: "#386aea",
      },
      {
        order: 6,
        color: "Brown",
        hexValue: "#996633",
      },
      {
        order: 7,
        color: "Pink",
        hexValue: "#ff2d55",
      },
    ];
    return flagColorArray;
  };
  /**
   * @method getDefaultAMPMforPosition Get default AM PM time
   * @param position is the user position FA, CP and FO
   */
  public getDefaultAMPMforPosition(position: string) {
    let defaultTime;
    if (position.toLowerCase() === "fa") {
      defaultTime = AMPMDefault.FA;
    } else {
      defaultTime = AMPMDefault.Pilot;
    }
    return defaultTime;
  }
}

//LinePropertyLastId - 101
//FilterLastId - 111
//SortLastId - 114
